import React, { useState, useEffect, useRef, useMemo } from "react";
import Sidebar from "../../composant_reutilisable/sidebar";
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from "../../composant_reutilisable/useAuth";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  FaPlus,
  FaShieldAlt,
  FaTrash,
  FaEdit,
  FaSortAmountUp,
  FaSortAmountDown,
  FaArrowLeft,
  FaArrowRight,
  FaChevronDown,
  FaMapMarkerAlt,
  FaSync,
  FaGlobe,
  FaHandshake,
  FaEllipsisV,
  FaOutdent,
  FaTimes,
  FaSignOutAlt,
  FaExchangeAlt,
  FaChevronUp,
  FaSearch,
  FaExclamationTriangle,
  FaDesktop,
  FaMobileAlt,
  FaCheckCircle,
  FaQuestionCircle,
  FaEye,
  FaHome,
  FaGlobeAfrica,
  FaWindowClose,
  FaPaperclip,
  FaTruckLoading,
  FaHistory,
} from "react-icons/fa";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import axios from "axios";
import Select from "react-select";
import { FaBoxesPacking } from "react-icons/fa6";
import GlossaireSidebar from "../../composant_reutilisable/glossaireSidebar";
import Pas_acces from "../../composant_reutilisable/pas_acces";
import MenuVisibilite from "../../composant_reutilisable/menu_visibilite";
import EntrerModal from "./EntrerModal";
import ModalConducteur from "./modal_conducteurs";
import ModalHistorique from "./modal_historique";

const Gestion_des_tours_international = ({ titre }) => {
  useAuth();
  const location = useLocation();
  const user_id = localStorage.getItem("userId");
  const { parcRef } = location.state || {};
  const [camions, setCamions] = useState([]);
  const [selectedCamion, setSelectedCamion] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingAjout, setIsLoadingAjout] = useState(false);
  const [isLoadingRemplacer, setIsLoadingRemplacer] = useState(false);
  const [isLoadingSorti, setIsLoadingSorti] = useState(false);
  const [isLoadingSortiRang, setIsLoadingSortiRang] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const [alert, setAlert] = useState({ message: "", type: "" });
  const [alertModal, setAlertModal] = useState({ message: "", type: "" });
  const [sortConfig, setSortConfig] = useState({
    key: "date_creation",
    direction: "descending",
  });
  const navigate = useNavigate();
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [teteVehicule, setTeteVehicule] = useState(null);
  const [queueVehicule, setQueueVehicule] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [nonArticuleVehicule, setNonArticuleVehicule] = useState(null);
  const [activeTab, setActiveTab] = useState("fifo");
  const [showInfo, setShowInfo] = useState(true);


  const dropdownRef = useRef(null);

  const [filteredImmatriculations, setFilteredImmatriculations] = useState([]);


  const [newCamion, setNewCamion] = useState({
    tete: null,
    queue: null,
    genre: "",
    immatriculation: "",
    nom_conducteur: "",
    numero_permis: "",
    categorie_permis: "",
    tel_conducteur: "",
    nom_bailleur: "",
    date_creation: "",
    date_modification: "",
    type_camion: "",
    proprietaire_tete: "",
    proprietaire_queue: "",
    charge_utile: "",
    parc: "",
    type_parc: "",
    numero_proprietaire_tete: "",
    numero_proprietaire_queue: "",
    numero_proprietaire_non_articule: "",
    nationalite_tete: "",
    nationalite_queue: "",
    nationalite_non_articule: "",
    code_nationalite_tete: "",
    code_nationalite_queue: "",
    code_nationalite_non_articule: "",
    droit_tour: "",
    droit_chargement: "",
    destination: "",
    nom_parc_tampon: "",
    date_arrivee: "",
    date_sortie: "",
    utilisateur_arrivee: "",
    utilisateur_sortie: "",
  });

  const [modifCamion, setModifCamion] = useState({
    tete: null,
    queue: null,
    tete__numero_immatriculation: null,
    queue__numero_immatriculation: null,
    genre: "",
    immatriculation: "",
    nom_conducteur: "",
    numero_permis: "",
    categorie_permis: "",
    tel_conducteur: "",
    nom_bailleur: "",
    date_creation: "",
    date_modification: "",
    type_camion: "",
    statut: "",
    proprietaire_tete: "",
    proprietaire_queue: "",
    charge_utile: "",
    parc: "",
    type_parc: "",
    numero_proprietaire_tete: "",
    numero_proprietaire_queue: "",
    numero_proprietaire_non_articule: "",
    nationalite_tete: "",
    nationalite_queue: "",
    nationalite_non_articule: "",
    code_nationalite_tete: "",
    code_nationalite_queue: "",
    code_nationalite_non_articule: "",
    droit_tour: "",
    droit_chargement: "",
    nom_parc_tampon: "",
    date_arrivee: "",
    date_sortie: "",
    utilisateur_arrivee: "",
    utilisateur_sortie: "",
  });

  const [showEntrerModal, setShowEntrerModal] = useState(false);
  const [showEntrerModalConducteur, setShowEntrerModalConducteur] = useState(false);
  const [showModalHistorique, setShowModalHistorique] = useState(false);

  const handleSaveEntrerData = async (data) => {
    const token = localStorage.getItem('access_token');
    try {
      const response = await fetch(`${process.env.REACT_APP_HOTE}/api/transfert-entrer-modal/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();

      if (result.success) {
        // Construire le message avec les immatriculations
        let immatriculations = [];

        if (data.infosCamion1) {
          immatriculations.push(data.infosCamion1.immatriculation);
        }

        if (data.infosCamion2) {
          immatriculations.push(data.infosCamion2.immatriculation);
        }

        const immatriculationsText = immatriculations.join(' + ');

        showAlert(`Mise en file effectuée avec succès pour ${immatriculationsText}`);
        fetchCamions()

        // Retourner le succès pour vider le formulaire
        return { success: true };
      } else {
        showAlert(`Erreur: ${result.error}`, 'danger');
        return { success: false, error: result.error };
      }
    } catch (error) {
      console.error('Erreur lors du transfert:', error);
      showAlert('Erreur réseau lors du transfert', 'danger');
      return { success: false, error: 'Erreur réseau' };
    } finally {
      setShowEntrerModal(false);
    }
  };

  const handlerRemplacerChauffeur = async (data) => {
    const token = localStorage.getItem('access_token');
    try {
      const response = await fetch(`${process.env.REACT_APP_HOTE}/api/remplacer-conducteur-tour/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();

      if (result.success) {
        // Construire le message avec les immatriculations
        let immatriculations = [];

        if (data.infosCamion1) {
          immatriculations.push(data.infosCamion1.immatriculation);
        }

        if (data.infosCamion2) {
          immatriculations.push(data.infosCamion2.immatriculation);
        }

        const immatriculationsText = immatriculations.join(' + ');

        showAlert(`Chauffeur remplacé avec succès pour ${immatriculationsText}`);
        fetchCamions();

        // Retourner le succès pour vider le formulaire
        return { success: true };
      } else {
        showAlert(`Erreur: ${result.error}`, 'danger');
        return { success: false, error: result.error };
      }
    } catch (error) {
      console.error('Erreur lors du transfert:', error);
      showAlert('Erreur réseau lors du transfert', 'danger');
      return { success: false, error: 'Erreur réseau' };
    } finally {
      setShowEntrerModalConducteur(false);
    }
  };

  useEffect(() => {
    if (user_id) {
      document.title = "Transportpro | Gestion des tours internationaux";
    }
  }, [user_id]);

  const [userData, setUserData] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCamion((prevCamion) => ({
      ...prevCamion,
      [name]: value,
    }));
  };



  const handleParcChange = (selectedOption) => {
    const selectedParc = parcs.find(
      (parc) => parc.id === selectedOption?.value
    );
    setNewCamion({
      ...newCamion,
      parc: selectedParc,
      type_parc: selectedParc?.type_parc || "",
    });
  };

  const handleParcChangeModif = (selectedOption) => {
    const selectedParc = parcs.find(
      (parc) => parc.id === selectedOption?.value
    );
    setModifCamion({
      ...modifCamion,
      parc: selectedParc.id,
      type_parc: selectedParc?.type_parc || "",
      parc__nom_parc: selectedParc?.nom_parc || "",
    });
  };


  const handleInputChangeModif = (e) => {
    const { name, value } = e.target;
    setModifCamion((prevModifCamion) => ({
      ...prevModifCamion,
      [name]: value,
    }));
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const handleShowAddModal = () => setShowAddModal(true);
  const handleCloseAddModal = () => setShowAddModal(false);

  const handleShowEditModal = () => setShowEditModal(true);
  const handleCloseEditModal = () => setShowEditModal(false);




  const [Villes, setVilles] = useState([]);
  const fetchVilles = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_HOTE + "/liste-ville/");
      if (response.ok) {
        const data = await response.json();
        // Format data for react-select
        const formattedData = data.map(ville => ({
          value: ville.nom_ville,
          label: ville.nom_ville,
          pays: ville.pays
        }));
        setVilles(formattedData);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des villes:", error);
    }
  };


  const [parcs, setParcs] = useState([]);
  const fetchParcs = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_HOTE + "/liste-parc/");
      if (response.ok) {
        const data = await response.json();
        const parcsinteNationaux = data.filter(
          (parc) => parc.type_parc === "international"
        );
        setParcs(parcsinteNationaux);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des parcs:", error);
    }
  };

  useEffect(() => {
    fetchParcs();
    fetchVilles();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    // Ajouter 1 heure pour corriger le décalage horaire
    date.setHours(date.getHours() + 1);
    const optionsDate = { day: "2-digit", month: "2-digit", year: "numeric" };
    const optionsTime = {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };
    const formattedDate = date.toLocaleDateString("fr-FR", optionsDate);
    const formattedTime = date.toLocaleTimeString("fr-FR", optionsTime);
    return `${formattedDate} ${formattedTime}`;
  };


  const [showColumnSelector, setShowColumnSelector] = useState(false);
  const columnLabels = {
    date_creation: "Date d'entrée",
    ordre: "Ordre",
    atellage: "Type d'attelage",
    camion: "Camion",
    reference_carte_transport_1: "Réf. carte transport 1",
    reference_carte_transport_2: "Réf. carte transport 2",
    tete: "Tracteur",
    queue: "Remorque",
    immatriculation: "Immatriculation",
    nationalite_vehicule: "Nationalité du véhicule",
    nationalite_carte_transport_tete: "Nationalités carte transport tracteur",
    nationalite_carte_transport_queue: "Nationalités carte transport remorque",
    nationalite_carte_transport_immatriculation: "Nationalités carte transport non articulé",
    proprietaire_tete: "Propriétaire tracteur",
    proprietaire_queue: "Propriétaire remorque",
    proprietaire_non_articule: "Propriétaire non articulé",
    numero_proprietaire_tete: "Tél. propriétaire tracteur",
    numero_proprietaire_queue: "Tél. propriétaire remorque",
    numero_proprietaire_non_articule: "Tél. propriétaire non articulé",
    charge_utile: "Charge utile totale",
    charge_utile1: "Charge utile 1",
    charge_utile2: "Charge utile 2",
    nombre_essieux1: "Essieux 1",
    nombre_essieux2: "Essieux 2",
    tuslock1: "Nombre de twist lock 1",
    tuslock2: "Nombre de twist lock 2",
    conducteur_principal: "Conducteur principal",
    numero_permis_principal: "Permis principal",
    categorie_permis_principal: "Catégorie permis principal",
    tel_conducteur_principal: "Tél. conducteur principal",
    conducteur_assistant: "Conducteur assistant",
    numero_permis_assistant: "Permis assistant",
    categorie_permis_assistant: "Catégorie permis assistant",
    tel_conducteur_assistant: "Tél. conducteur assistant",
    type_camion: "Type de camion",
    statut: "Statut",
    fret: "Fret",
    nature_fret: "Nature du fret",
    ref_categorie: "Référence catégorie",
    destination: "Destination",
    parc: "Parc",
    type_parc: "Type de parc",
    utilisateur: "Ajouté par",
  };

  const [visibleColumns, setVisibleColumns] = useState({
    date_creation: true,
    ordre: true,
    atellage: false,
    camion: true,
    reference_carte_transport_1: false,
    reference_carte_transport_2: false,
    tete: false,
    queue: false,
    immatriculation: false,
    nationalite_vehicule: false,
    nationalite_carte_transport_tete: false,
    nationalite_carte_transport_queue: false,
    nationalite_carte_transport_immatriculation: false,
    proprietaire_tete: false,
    proprietaire_queue: false,
    proprietaire_non_articule: false,
    numero_proprietaire_tete: false,
    numero_proprietaire_queue: false,
    numero_proprietaire_non_articule: false,
    charge_utile: true,
    charge_utile1: false,
    charge_utile2: false,
    nombre_essieux1: false,
    nombre_essieux2: false,
    tuslock1: false,
    tuslock2: false,
    conducteur_principal: true,
    numero_permis_principal: false,
    categorie_permis_principal: false,
    tel_conducteur_principal: true,
    conducteur_assistant: false,
    numero_permis_assistant: false,
    categorie_permis_assistant: false,
    tel_conducteur_assistant: false,
    type_camion: true,
    statut: true,
    fret: false,
    nature_fret: false,
    ref_categorie: false,
    destination: false,
    parc: true,
    type_parc: false,
    utilisateur: false,
  });

  const [showColumnChargementSelector, setShowColumnChargementSelector] = useState(false);
  const columnChargementLabels = {
    date_creation: "Date d'entrée",
    date_selection: "Date de sélection",
    ordre: "Ordre",
    atellage: "Type d'attelage",
    camion: "Camion",
    reference_carte_transport_1: "Réf. carte transport 1",
    reference_carte_transport_2: "Réf. carte transport 2",
    tete: "Tracteur",
    queue: "Remorque",
    immatriculation: "Immatriculation",
    proprietaire_tete: "Propriétaire tracteur",
    proprietaire_queue: "Propriétaire remorque",
    proprietaire_non_articule: "Propriétaire non articulé",
    nationalite_vehicule: "Nationalité du véhicule",
    nationalite_carte_transport_tete: "Nationalités carte transport tracteur",
    nationalite_carte_transport_queue: "Nationalités carte transport remorque",
    nationalite_carte_transport_immatriculation: "Nationalités carte transport non articulé",
    numero_proprietaire_tete: "Tél. propriétaire tracteur",
    numero_proprietaire_queue: "Tél. propriétaire remorque",
    numero_proprietaire_non_articule: "Tél. propriétaire non articulé",
    charge_utile: "Charge utile totale",
    charge_utile1: "Charge utile 1",
    charge_utile2: "Charge utile 2",
    tuslock1: "Nombre de twist lock 1",
    tuslock2: "Nombre de twist lock",
    nombre_essieux1: "Essieux 1",
    nombre_essieux2: "Essieux 2",
    conducteur_principal: "Conducteur principal",
    numero_permis_principal: "Permis principal",
    categorie_permis_principal: "Catégorie permis principal",
    tel_conducteur_principal: "Tél. conducteur principal",
    conducteur_assistant: "Conducteur assistant",
    numero_permis_assistant: "Permis assistant",
    categorie_permis_assistant: "Catégorie permis assistant",
    tel_conducteur_assistant: "Tél. conducteur assistant",
    type_camion: "Type de camion",
    statut: "Statut",
    // fret: "Fret",
    lot_ref: "Référence lot",
    lot_ref2: "Référence lot2",
    nature_fret: "Nature du fret",
    ref_categorie: "Référence catégorie",
    destination: "Destination",
    parc: "Parc",
    type_parc: "Type de parc",
    utilisateur: "Ajouté par",
  };

  const [visibleChargementColumns, setVisibleChargementColumns] = useState({
    date_creation: false,
    date_selection: true,
    ordre: true,
    atellage: false,
    camion: true,
    reference_carte_transport_1: false,
    reference_carte_transport_2: false,
    tete: false,
    queue: false,
    immatriculation: false,
    proprietaire_tete: false,
    proprietaire_queue: false,
    proprietaire_non_articule: false,
    nationalite_vehicule: false,
    nationalite_carte_transport_tete: false,
    nationalite_carte_transport_queue: false,
    nationalite_carte_transport_immatriculation: false,
    numero_proprietaire_tete: false,
    numero_proprietaire_queue: false,
    numero_proprietaire_non_articule: false,
    charge_utile: true,
    charge_utile1: false,
    charge_utile2: false,
    nombre_essieux1: false,
    nombre_essieux2: false,
    tuslock1: false,
    tuslock2: false,
    conducteur_principal: true,
    numero_permis_principal: false,
    categorie_permis_principal: false,
    tel_conducteur_principal: false,
    conducteur_assistant: false,
    numero_permis_assistant: false,
    categorie_permis_assistant: false,
    tel_conducteur_assistant: false,
    type_camion: true,
    statut: true,
    // fret: true,
    lot_ref: true,
    lot_ref2: false,
    nature_fret: false,
    ref_categorie: false,
    destination: false,
    parc: true,
    type_parc: false,
    utilisateur: false,
  });

  // Même chose pour lettre_voiture et appele_camion
  const [showLettreVoitureColumnSelector, setShowLettreVoitureColumnSelector] = useState(false);
  const columnLettreVoitureLabels = {
    arrivee_lettre_voiture: "Date d'émission LV",
    ...columnChargementLabels,
    ref_appeler_camion: "Référence appel camion",
    date_entree_appeler_camion: "Date entrée appel camion",
    date_sortie_appeler_camion: "Date sortie appel camion",
    poids_effectif_appeler_camion: "Poids effectif appel camion",
    unite_poids_appeler_camion: "Unité poids appel camion",
    date_arrivee_parc_tampon: "Arrivée parc tampon"
  };

  const [visibleLettreVoitureColumns, setVisibleLettreVoitureColumns] = useState({
    arrivee_lettre_voiture: true,
    ...visibleChargementColumns,
    date_selection: false,
    ref_appeler_camion: false,
    date_entree_appeler_camion: false,
    date_sortie_appeler_camion: false,
    poids_effectif_appeler_camion: false,
    unite_poids_appeler_camion: false,
    date_arrivee_parc_tampon: false
  });

  // Même chose pour lettre_voiture et appele_camion
  const [showAppeleCamionColumnSelector, setShowAppeleCamionColumnSelector] = useState(false);
  const columnAppeleCamionLabels = {
    ...columnChargementLabels,
    ref_appeler_camion: "Référence appel camion",
    date_entree_appeler_camion: "Date entrée appel camion",
    date_sortie_appeler_camion: "Date sortie appel camion",
    poids_effectif_appeler_camion: "Poids effectif appel camion",
    unite_poids_appeler_camion: "Unité poids appel camion",
    date_arrivee_parc_tampon: "Arrivée parc tampon"
  };

  const [visibleAppeleCamionColumns, setVisibleAppeleCamionColumns] = useState({
    ...visibleChargementColumns,
    ref_appeler_camion: false,
    date_entree_appeler_camion: false,
    date_sortie_appeler_camion: false,
    poids_effectif_appeler_camion: false,
    unite_poids_appeler_camion: false,
    date_arrivee_parc_tampon: true
  });


  const fetchCamions = async (page = currentPage, perPage = itemsPerPage) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_HOTE}/liste-camions-dispo/?page=${page}&per_page=${perPage}&parcRef=${parcRef || userData?.parc}`);
      if (!response.ok) {
        throw new Error("Erreur lors de la récupération des camions");
      }

      // const data = await response.json();
      // setCamions(data.camions || []);

      const data = await response.json();

      const camionsTries = (data.camions || []).sort(
        (a, b) => b.ordre - a.ordre
      );

      const camionsAvecRang = camionsTries.map((camion, index, array) => ({
        ...camion,
        rang: array.length - index,
      }));

      setCamions(camionsAvecRang);
      setCurrentPage(data.page || 1);
      setTotalPages(data.total_pages || 1);
      setTotalItems(data.total_items || 0);

      if (itemsPerPage === null) {
        setItemsPerPage(data.nombre_elements_par_page || 10);
      }
    } catch (error) {
      console.error("Erreur lors du fetch des camions :", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchCamions();
    };
    fetchData();
    fetchParametres();
  }, []);

  const [previewMode, setPreviewMode] = useState(false);


  const safeLower = (val) => {
    return typeof val === "string" ? val.toLowerCase() : "";
  };

  const filterCamions = (data, searchTerm, visibleColumns) => {
    const search = safeLower(searchTerm);

    return data.filter((n) => {
      const matchVisible = Object.keys(visibleColumns)
        .filter((key) => visibleColumns[key])
        .some((key) => {

          // 🔥 CAS SPÉCIAL CAMION
          if (key === "camion") {
            const camionValue =
              n.atellage === "1"
                ? `${n.tete || ""} ${n.queue || ""}`
                : n.immatriculation || "";

            return safeLower(camionValue).includes(search);
          }

          // 🔥 CAS NORMAL
          if (key in n) {
            return safeLower(n[key]).includes(search);
          }

          return false;
        });

      return matchVisible;
    });
  };

  // const filteredCamions = camions.filter((n) => {
  //   const searchTermLower = searchTerm.toLowerCase();

  //   // Vérifier tous les champs possibles
  //   return (
  //     // Informations véhicule
  //     (n.tete__numero_immatriculation?.toLowerCase().includes(searchTermLower)) ||
  //     (n.queue__numero_immatriculation?.toLowerCase().includes(searchTermLower)) ||
  //     (n.immatriculation?.toLowerCase().includes(searchTermLower)) ||
  //     (n.proprietaire_tete?.toLowerCase().includes(searchTermLower)) ||
  //     (n.proprietaire_queue?.toLowerCase().includes(searchTermLower)) ||
  //     (n.proprietaire_non_articule?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_proprietaire_tete?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_proprietaire_queue?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_proprietaire_non_articule?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nationalite_tete?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nationalite_queue?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nationalite_non_articule?.toLowerCase().includes(searchTermLower)) ||
  //     (n.code_nationalite_tete?.toLowerCase().includes(searchTermLower)) ||
  //     (n.code_nationalite_queue?.toLowerCase().includes(searchTermLower)) ||
  //     (n.code_nationalite_non_articule?.toLowerCase().includes(searchTermLower)) ||

  //     // Informations conducteur
  //     (n.nom_conducteur?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_permis?.toLowerCase().includes(searchTermLower)) ||
  //     (n.categorie_permis?.toLowerCase().includes(searchTermLower)) ||
  //     (n.tel_conducteur?.toLowerCase().includes(searchTermLower)) ||
  //     (n.conducteur_principal?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_permis_principal?.toLowerCase().includes(searchTermLower)) ||
  //     (n.categorie_permis_principal?.toLowerCase().includes(searchTermLower)) ||
  //     (n.tel_conducteur_principal?.toLowerCase().includes(searchTermLower)) ||
  //     (n.conducteur_assistant?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_permis_assistant?.toLowerCase().includes(searchTermLower)) ||
  //     (n.categorie_permis_assistant?.toLowerCase().includes(searchTermLower)) ||
  //     (n.tel_conducteur_assistant?.toLowerCase().includes(searchTermLower)) ||

  //     // Informations techniques
  //     (n.type_camion?.toLowerCase().includes(searchTermLower)) ||
  //     (n.genre?.toLowerCase().includes(searchTermLower)) ||
  //     (n.charge_utile?.toString().includes(searchTerm)) ||
  //     (n.charge_utile1?.toString().includes(searchTerm)) ||
  //     (n.charge_utile2?.toString().includes(searchTerm)) ||
  //     (n.nombre_essieux1?.toString().includes(searchTerm)) ||
  //     (n.nombre_essieux2?.toString().includes(searchTerm)) ||
  //     (n.tuslock1?.toString().includes(searchTerm)) ||
  //     (n.tuslock2?.toString().includes(searchTerm)) ||

  //     // Fret et destination
  //     (n.fret?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nature_fret?.toLowerCase().includes(searchTermLower)) ||
  //     (n.ref_categorie?.toLowerCase().includes(searchTermLower)) ||
  //     (n.destination?.toLowerCase().includes(searchTermLower)) ||
  //     (n.pays_destination?.toLowerCase().includes(searchTermLower)) ||

  //     // Parc et statut
  //     (n.parc?.toLowerCase().includes(searchTermLower)) ||
  //     (n.type_parc?.toLowerCase().includes(searchTermLower)) ||
  //     (n.statut?.toLowerCase().includes(searchTermLower)) ||
  //     (n.droit_tour?.toLowerCase().includes(searchTermLower)) ||
  //     (n.droit_chargement?.toLowerCase().includes(searchTermLower)) ||

  //     // Dates
  //     (n.date_creation?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_modification?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_selection?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_arrivee_parc_tampon?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_sortie_parc_tampon?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_sortie_reele?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_sortie_prevuee?.toString().toLowerCase().includes(searchTermLower)) ||

  //     // Utilisateurs
  //     (n.utilisateur?.toLowerCase().includes(searchTermLower)) ||
  //     (n.utilisateur_arrivee?.toLowerCase().includes(searchTermLower)) ||
  //     (n.utilisateur_sortie?.toLowerCase().includes(searchTermLower)) ||

  //     // Autres
  //     (n.nom_parc_tampon?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nom_bailleur?.toLowerCase().includes(searchTermLower)) ||
  //     (n.reference_carte_transport_1?.toLowerCase().includes(searchTermLower)) ||
  //     (n.reference_carte_transport_2?.toLowerCase().includes(searchTermLower)) ||

  //     // Recherche combinée pour le camion complet
  //     (`${n.tete || ''} ${n.queue || ''}`.toLowerCase().includes(searchTermLower)) ||
  //     (`${n.tete__numero_immatriculation || ''} ${n.queue__numero_immatriculation || ''}`.toLowerCase().includes(searchTermLower))
  //   );
  // });

  const filteredCamions = filterCamions(
    camions,
    searchTerm,
    visibleColumns
  );

  const sortedCamions = [...filteredCamions].sort((a, b) => {
    if (!sortConfig.key) return 0;

    const aCamion = `${a.tete__numero_immatriculation} + ${a.queue__numero_immatriculation}`;
    const bCamion = `${b.tete__numero_immatriculation} + ${b.queue__numero_immatriculation}`;

    let aValue = a[sortConfig.key];
    let bValue = b[sortConfig.key];

    if (sortConfig.key === "camion") {
      aValue = aCamion;
      bValue = bCamion;
    }

    aValue = aValue ? aValue.toString().toLowerCase() : "";
    bValue = bValue ? bValue.toString().toLowerCase() : "";

    if (aValue < bValue) return sortConfig.direction === "ascending" ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === "ascending" ? 1 : -1;
    return 0;
  });

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const handleShowDeleteModal = (camion) => {
    setSelectedCamion(camion);
    setTimeout(() => {
      setShowDeleteModal(true);
    }, 0);
  };


  const [showSortirModal, setShowSortirModal] = useState(false);
  const [camionToSortir, setCamionToSortir] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleShowSortirModal = (camion) => {
    setCamionToSortir(camion);
    setShowSortirModal(true);
  };

  const handleCloseSortirModal = () => {
    setShowSortirModal(false);
  };

  const handleFaireSortirCamion = async () => {
    if (camionToSortir) {
      setIsLoadingSorti(true);
      try {
        const response = await fetch(
          process.env.REACT_APP_HOTE +
          `/faire-sortir/${camionToSortir.id}/${user_id}/`,
          {
            method: "PUT",
          }
        );

        const data = await response.json();
        if (response.ok) {
          await fetchCamions();
          // await fetchImmatriculations();
          setSelectedFile(null);
          if (activeTab === "fifo") {
            await fetchCamions();
          } else {
            await fetchCamionsChargement();
            await fetchCamionsLettreVoiture();
            await fetchCamionsParcTampon();
          }
          showAlert(data.message);
        } else {
          console.error("Erreur lors de la sorti du camion");
        }
      } catch (error) {
        console.error("Erreur réseau:", error);
      } finally {
        setIsLoadingSorti(false);
        setShowSortirModal(false);
      }
    }
  };


  const handleConfirmerSortieDeRang = async () => {
    setIsLoadingSortiRang(true);
    try {
      if (selectedCamion) {
        const token = localStorage.getItem('access_token');
        const response = await fetch(
          `${process.env.REACT_APP_HOTE}/api/changer-statut-quitter/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
              tour_id: selectedCamion.id,
              user_id: user_id
            }),
          }
        );

        const data = await response.json();

        if (response.ok && data.success) {
          showAlert(data.message);
          if (activeTab === "fifo") {
            await fetchCamions();
          } else {
            await fetchCamionsChargement();
            await fetchCamionsLettreVoiture();
            await fetchCamionsParcTampon();
          }
        } else {
          showAlert(data.error || "Erreur lors de la sortie de rang", "danger");
        }
      }
    } catch (error) {
      console.error("Erreur lors de la sortie de rang:", error);
      showAlert("Une erreur s'est produite", "danger");
    } finally {
      setIsLoadingSortiRang(false);
      setAfficherModalSortie(false);
    }
  };

  const showAlert = (message, type = "success") => {
    setAlert({ message, type });
  };

  const showAlertModal = (message, type = "success") => {
    setAlertModal({ message, type });
  };

  const fermerNotif = () => {
    setAlert({ message: "", type: "" });
    setAlertModal({ message: "", type: "" });
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_HOTE + `/recup-info-profil/${user_id}/`
        );
        if (response.ok) {
          const data = await response.json();
          setUserData(data);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération du profil:", error);
      }
    };

    fetchUserData();
  }, [user_id]);

  const [bailleurs, setBailleurs] = useState([]);


  const [camionsChargement, setCamionsChargement] = useState([]);
  const [currentPageChargement, setCurrentPageChargement] = useState(1);
  const [totalPagesChargement, setTotalPagesChargement] = useState(1);
  const [totalItemsChargement, setTotalItemsChargement] = useState(0);
  const [searchTermChargement, setSearchTermChargement] = useState("");
  const [parcsTampon, setParcsTampon] = useState([]);
  const [isLoadingParcs, setIsLoadingParcs] = useState(false);

  const fetchCamionsChargement = async (page = 1) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_HOTE}/liste-selection/?page=${page}&parcRef=${parcRef || userData?.parc}`);

      if (!response.ok) {
        throw new Error(
          "Erreur lors de la récupération des camions en chargement"
        );
      }

      const data = await response.json();

      const camionsTries = (data.camions || []).sort(
        (a, b) => b.date_selection - a.date_selection
      );

      const camionsAvecRang = camionsTries.map((camion, index, array) => ({
        ...camion,
        rang: array.length - index,
      }));

      setCamionsChargement(camionsAvecRang);
      // setCamionsChargement(data.camions || []);
      setCurrentPageChargement(data.page || 1);
      setTotalPagesChargement(data.total_pages || 1);
      setTotalItemsChargement(data.total_items || 0);
    } catch (error) {
      console.error("Erreur lors du fetch des camions en chargement:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const [camionsLettreVoiture, setCamionsLettreVoiture] = useState([]);
  const [currentPageLettreVoiture, setCurrentPageLettreVoiture] = useState(1);
  const [totalPagesLettreVoiture, setTotalPagesLettreVoiture] = useState(1);
  const [totalItemsLettreVoiture, setTotalItemsLettreVoiture] = useState(0);
  const [searchTermLettreVoiture, setSearchTermLettreVoiture] = useState("");

  const fetchCamionsLettreVoiture = async (page = 1) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_HOTE}/liste-lettre-voiture/?page=${page}&parcRef=${parcRef || userData?.parc}`);

      if (!response.ok) {
        throw new Error(
          "Erreur lors de la récupération des camions en chargement"
        );
      }

      const data = await response.json();

      const camionsTries = (data.camions || []).sort(
        (a, b) => b.arrivee_lettre_voiture - a.arrivee_lettre_voiture
      );

      const camionsAvecRang = camionsTries.map((camion, index, array) => ({
        ...camion,
        rang: array.length - index,
      }));

      setCamionsLettreVoiture(camionsAvecRang);
      // setCamionsLettreVoiture(data.camions || []);
      setCurrentPageLettreVoiture(data.page || 1);
      setTotalPagesLettreVoiture(data.total_pages || 1);
      setTotalItemsLettreVoiture(data.total_items || 0);
    } catch (error) {
      console.error("Erreur lors du fetch des camions:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const [camionsAppeleCamion, setCamionsAppeleCamion] = useState([]);
  const [currentPageAppeleCamion, setCurrentPageAppeleCamion] = useState(1);
  const [totalPagesAppeleCamion, setTotalPagesAppeleCamion] = useState(1);
  const [totalItemsAppeleCamion, setTotalItemsAppeleCamion] = useState(0);
  const [searchTermAppeleCamion, setSearchTermAppeleCamion] = useState("");

  const fetchCamionsParcTampon = async (page = 1) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_HOTE}/liste-camion-parc-tampon/?page=${page}&parcRef=${parcRef || userData?.parc}`);

      if (!response.ok) {
        throw new Error(
          "Erreur lors de la récupération des camions en chargement"
        );
      }

      const data = await response.json();

      const camionsTries = (data.camions || []).sort(
        (a, b) => b.ordre - a.ordre
      );

      const camionsAvecRang = camionsTries.map((camion, index, array) => ({
        ...camion,
        rang: array.length - index,
      }));

      setCamionsAppeleCamion(camionsAvecRang);
      // setCamionsAppeleCamion(data.camions || []);
      setCurrentPageAppeleCamion(data.page || 1);
      setTotalPagesAppeleCamion(data.total_pages || 1);
      setTotalItemsAppeleCamion(data.total_items || 0);
    } catch (error) {
      console.error("Erreur lors du fetch des camions:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const [afficherModalSortie, setAfficherModalSortie] = useState(false);
  const handleFaireSortirClick = (camion) => {
    if (!camion || !camion.id) {
      showAlert("Aucun camion sélectionné", "danger");
      return;
    }
    setSelectedCamion(camion);
    setAfficherModalSortie(true);
  };


  const handleConfirmerSortir = async () => {
    setIsLoadingSortiRang(true);
    try {
      if (!selectedCamion || !selectedCamion.id) {
        showAlert("Aucun camion sélectionné", "danger");
        return;
      }

      const token = localStorage.getItem('access_token');

      const response = await fetch(
        `${process.env.REACT_APP_HOTE}/api/changer-statut-tour/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify({
            tour_id: selectedCamion.id,
            user_id: user_id,
          })
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `Erreur HTTP: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        showAlert(
          result.message ||
          `${result.immatriculation || 'Le camion'} vient de sortir.`
        );

        if (activeTab === "fifo") {
          await fetchCamions();
        } else {
          await fetchCamionsChargement();
          await fetchCamionsLettreVoiture();
          await fetchCamionsParcTampon();
        }

      } else {
        showAlert(`Erreur: ${result.error}`, 'danger');
      }
    } catch (error) {
      console.error('Erreur lors du changement de statut:', error);
      showAlert(
        error.message || 'Erreur lors du changement de statut',
        'danger'
      );
    } finally {
      setIsLoadingSortiRang(false);
      setAfficherModalSortie(false);
    }
  };


  // Récupération des paramètres depuis le backend
  const [delai_renonciation, setDelai_renonciation] = useState("fifo");
  const fetchParametres = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_HOTE}/info-parametres-notifications/`
      );
      if (!response.ok)
        throw new Error("Erreur lors de la récupération des paramètres");
      const result = await response.json();
      if (result.success && result.data) {
        setDelai_renonciation(result.data.delai_renonciation || 5);
      }
    } catch (error) {
      console.error("Erreur lors du fetch des paramètres :", error);
    }
  };



  const [showStatutModal, setShowStatutModal] = useState(false);
  const [showStatutConducteurModal, setShowStatutConducteurModal] = useState(false);
  const [showBailleursModal, setShowBailleursModal] = useState(false);
  const [showRemplacerCamionModal, setShowRemplacerCamionModal] = useState(false);


  const handleShowStatutModal = (camion) => {
    setSelectedCamion(camion);
    setShowStatutModal(true);
  };

  const handleCloseStatutModal = () => {
    setShowStatutModal(false);
  };

  const handleShowStatutConducteurModal = (camion) => {
    setSelectedCamion(camion);
    setShowStatutConducteurModal(true);
  };

  const handleCloseStatutConducteurModal = () => {
    setShowStatutConducteurModal(false);
  };

  const handleShowBailleursModal = (camion) => {
    const bailleursData = camion?.bailleurs_affilie_1 || [];
    setBailleurs(bailleursData);
    setSelectedCamion(camion);
    setShowBailleursModal(true);
  };

  const handleCloseBailleursModal = () => {
    setShowBailleursModal(false);
  };

  const handleShowRemplacerModal = (camion) => {
    setSelectedCamion(camion);
    setShowRemplacerCamionModal(true);
  };

  const handleCloseRemplacerModal = () => {
    setShowRemplacerCamionModal(false);
  };


  const handleChangerstatut = async (camion) => {
    setIsLoading(true);
    try {
      if (selectedCamion?.id) {
        const response = await fetch(
          `${process.env.REACT_APP_HOTE}/changer-statut/${selectedCamion?.id}/${user_id}/`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();
        if (response.ok) {
          showAlert("Statut changé avec succès !");
          await fetchCamions();
        } else {
          showAlert(data.error, "danger");
        }
      }
    } catch (error) {
      console.error("Erreur lors du changement de statut:", error);
      showAlert("Une erreur s'est produite", "danger");
    } finally {
      setIsLoading(false);
      setShowStatutModal(false);
    }
  };

  const handleConducteurstatut = async (camion) => {
    setIsLoading(true);
    try {
      if (selectedCamion?.id) {
        const response = await fetch(
          `${process.env.REACT_APP_HOTE}/chauffeur-indisponible/${selectedCamion?.id}/${user_id}/`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();
        if (response.ok) {
          showAlert("Statut changé avec succès !");
          await fetchCamions();
        } else {
          showAlert(data.error, "danger");
        }
      }
    } catch (error) {
      console.error("Erreur lors du changement de statut:", error);
      showAlert("Une erreur s'est produite", "danger");
    } finally {
      setIsLoading(false);
      setShowStatutConducteurModal(false);
    }
  };

  const handleRemplacerCamion = async () => {
    setIsLoadingRemplacer(true);
    try {
      if (selectedCamion) {
        const token = localStorage.getItem('access_token');
        const response = await fetch(
          `${process.env.REACT_APP_HOTE}/api/remplacement-manuelle/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
              tour_id: selectedCamion.id,
              user_id: user_id
            }),
          }
        );

        const data = await response.json();

        if (response.ok && data.success) {
          showAlert(data.message);
          if (activeTab === "fifo") {
            await fetchCamions();
          } else {
            await fetchCamionsChargement();
            await fetchCamionsLettreVoiture();
            await fetchCamionsParcTampon();
          }
        } else {
          showAlert(data.error || "Erreur lors de l'amendement", "danger");
        }
      }
    } catch (error) {
      console.error("Erreur lors de l'amendement':", error);
      showAlert("Une erreur s'est produite", "danger");
    } finally {
      setIsLoadingRemplacer(false);
      setShowRemplacerCamionModal(false);
    }
  };

  const [showParcTamponModal, setShowParcTamponModal] = useState(false);
  const [selectedParcTampon, setSelectedParcTampon] = useState(null);

  const handleShowParcTamponModal = (camion) => {
    setSelectedCamion(camion);
    setShowParcTamponModal(true);
  };

  const handleCloseParcTamponModal = () => {
    setShowParcTamponModal(false);
    setSelectedParcTampon(null);
  };


  const [loading, setLoading] = useState(true);
  const [afficherModalAssigner, setAfficherModalAssigner] = useState(false);
  const [selectedFret, setSelectedFret] = useState(null);
  const [allCamionsGroups, setAllCamionsGroups] = useState(null);
  const [paginationGroups, setPaginationGroups] = useState(null);
  const [categorie, setCategorie] = useState("internationaux"); // Valeur par défaut

  // Nouvelle fonction pour charger les parcs tampon
  const fetchParcsTampon = async () => {
    setIsLoadingParcs(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_HOTE}/liste-parc-tampon/`
      );
      if (response.ok) {
        const data = await response.json();
        // setParcsTampon(data.parcs);
        setParcsTampon(Array.isArray(data) ? data : []);
      }
    } catch (error) {
      console.error("Erreur chargement parcs tampon:", error);
      setParcsTampon([]);
    } finally {
      setIsLoadingParcs(false);
    }
  };


  const [pays, setPays] = useState([]);
  const fetchPays = async () => {
    try {
      const paysList = [
        { value: 'Afghanistan', label: 'Afghanistan' },
        { value: 'Afrique du Sud', label: 'Afrique du Sud' },
        { value: 'Albanie', label: 'Albanie' },
        { value: 'Algérie', label: 'Algérie' },
        { value: 'Allemagne', label: 'Allemagne' },
        { value: 'Andorre', label: 'Andorre' },
        { value: 'Angola', label: 'Angola' },
        { value: 'Antigua-et-Barbuda', label: 'Antigua-et-Barbuda' },
        { value: 'Arabie saoudite', label: 'Arabie saoudite' },
        { value: 'Argentine', label: 'Argentine' },
        { value: 'Arménie', label: 'Arménie' },
        { value: 'Australie', label: 'Australie' },
        { value: 'Autriche', label: 'Autriche' },
        { value: 'Azerbaïdjan', label: 'Azerbaïdjan' },
        { value: 'Bahamas', label: 'Bahamas' },
        { value: 'Bahreïn', label: 'Bahreïn' },
        { value: 'Bangladesh', label: 'Bangladesh' },
        { value: 'Barbade', label: 'Barbade' },
        { value: 'Belgique', label: 'Belgique' },
        { value: 'Belize', label: 'Belize' },
        { value: 'Bénin', label: 'Bénin' },
        { value: 'Bhoutan', label: 'Bhoutan' },
        { value: 'Biélorussie', label: 'Biélorussie' },
        { value: 'Birmanie', label: 'Birmanie' },
        { value: 'Bolivie', label: 'Bolivie' },
        { value: 'Bosnie-Herzégovine', label: 'Bosnie-Herzégovine' },
        { value: 'Botswana', label: 'Botswana' },
        { value: 'Brésil', label: 'Brésil' },
        { value: 'Brunei', label: 'Brunei' },
        { value: 'Bulgarie', label: 'Bulgarie' },
        { value: 'Burkina Faso', label: 'Burkina Faso' },
        { value: 'Burundi', label: 'Burundi' },
        { value: 'Cambodge', label: 'Cambodge' },
        { value: 'Cameroun', label: 'Cameroun' },
        { value: 'Canada', label: 'Canada' },
        { value: 'Cap-Vert', label: 'Cap-Vert' },
        { value: 'Chili', label: 'Chili' },
        { value: 'Chine', label: 'Chine' },
        { value: 'Chypre', label: 'Chypre' },
        { value: 'Colombie', label: 'Colombie' },
        { value: 'Comores', label: 'Comores' },
        { value: 'Congo', label: 'Congo' },
        { value: 'Corée du Nord', label: 'Corée du Nord' },
        { value: 'Corée du Sud', label: 'Corée du Sud' },
        { value: 'Costa Rica', label: 'Costa Rica' },
        { value: 'Côte d\'Ivoire', label: 'Côte d\'Ivoire' },
        { value: 'Croatie', label: 'Croatie' },
        { value: 'Cuba', label: 'Cuba' },
        { value: 'Danemark', label: 'Danemark' },
        { value: 'Djibouti', label: 'Djibouti' },
        { value: 'Dominique', label: 'Dominique' },
        { value: 'Égypte', label: 'Égypte' },
        { value: 'Émirats arabes unis', label: 'Émirats arabes unis' },
        { value: 'Équateur', label: 'Équateur' },
        { value: 'Érythrée', label: 'Érythrée' },
        { value: 'Espagne', label: 'Espagne' },
        { value: 'Estonie', label: 'Estonie' },
        { value: 'Eswatini', label: 'Eswatini' },
        { value: 'États-Unis', label: 'États-Unis' },
        { value: 'Éthiopie', label: 'Éthiopie' },
        { value: 'Fidji', label: 'Fidji' },
        { value: 'Finlande', label: 'Finlande' },
        { value: 'France', label: 'France' },
        { value: 'Gabon', label: 'Gabon' },
        { value: 'Gambie', label: 'Gambie' },
        { value: 'Géorgie', label: 'Géorgie' },
        { value: 'Ghana', label: 'Ghana' },
        { value: 'Grèce', label: 'Grèce' },
        { value: 'Grenade', label: 'Grenade' },
        { value: 'Guatemala', label: 'Guatemala' },
        { value: 'Guinée', label: 'Guinée' },
        { value: 'Guinée équatoriale', label: 'Guinée équatoriale' },
        { value: 'Guinée-Bissau', label: 'Guinée-Bissau' },
        { value: 'Guyana', label: 'Guyana' },
        { value: 'Haïti', label: 'Haïti' },
        { value: 'Honduras', label: 'Honduras' },
        { value: 'Hongrie', label: 'Hongrie' },
        { value: 'Îles Cook', label: 'Îles Cook' },
        { value: 'Îles Marshall', label: 'Îles Marshall' },
        { value: 'Îles Salomon', label: 'Îles Salomon' },
        { value: 'Inde', label: 'Inde' },
        { value: 'Indonésie', label: 'Indonésie' },
        { value: 'Irak', label: 'Irak' },
        { value: 'Iran', label: 'Iran' },
        { value: 'Irlande', label: 'Irlande' },
        { value: 'Islande', label: 'Islande' },
        { value: 'Israël', label: 'Israël' },
        { value: 'Italie', label: 'Italie' },
        { value: 'Jamaïque', label: 'Jamaïque' },
        { value: 'Japon', label: 'Japon' },
        { value: 'Jordanie', label: 'Jordanie' },
        { value: 'Kazakhstan', label: 'Kazakhstan' },
        { value: 'Kenya', label: 'Kenya' },
        { value: 'Kirghizistan', label: 'Kirghizistan' },
        { value: 'Kiribati', label: 'Kiribati' },
        { value: 'Koweït', label: 'Koweït' },
        { value: 'Laos', label: 'Laos' },
        { value: 'Lesotho', label: 'Lesotho' },
        { value: 'Lettonie', label: 'Lettonie' },
        { value: 'Liban', label: 'Liban' },
        { value: 'Liberia', label: 'Liberia' },
        { value: 'Libye', label: 'Libye' },
        { value: 'Liechtenstein', label: 'Liechtenstein' },
        { value: 'Lituanie', label: 'Lituanie' },
        { value: 'Luxembourg', label: 'Luxembourg' },
        { value: 'Macédoine du Nord', label: 'Macédoine du Nord' },
        { value: 'Madagascar', label: 'Madagascar' },
        { value: 'Malaisie', label: 'Malaisie' },
        { value: 'Malawi', label: 'Malawi' },
        { value: 'Maldives', label: 'Maldives' },
        { value: 'Mali', label: 'Mali' },
        { value: 'Malte', label: 'Malte' },
        { value: 'Maroc', label: 'Maroc' },
        { value: 'Maurice', label: 'Maurice' },
        { value: 'Mauritanie', label: 'Mauritanie' },
        { value: 'Mexique', label: 'Mexique' },
        { value: 'Micronésie', label: 'Micronésie' },
        { value: 'Moldavie', label: 'Moldavie' },
        { value: 'Monaco', label: 'Monaco' },
        { value: 'Mongolie', label: 'Mongolie' },
        { value: 'Monténégro', label: 'Monténégro' },
        { value: 'Mozambique', label: 'Mozambique' },
        { value: 'Namibie', label: 'Namibie' },
        { value: 'Nauru', label: 'Nauru' },
        { value: 'Népal', label: 'Népal' },
        { value: 'Nicaragua', label: 'Nicaragua' },
        { value: 'Niger', label: 'Niger' },
        { value: 'Nigeria', label: 'Nigeria' },
        { value: 'Norvège', label: 'Norvège' },
        { value: 'Nouvelle-Zélande', label: 'Nouvelle-Zélande' },
        { value: 'Oman', label: 'Oman' },
        { value: 'Ouganda', label: 'Ouganda' },
        { value: 'Ouzbékistan', label: 'Ouzbékistan' },
        { value: 'Pakistan', label: 'Pakistan' },
        { value: 'Palaos', label: 'Palaos' },
        { value: 'Palestine', label: 'Palestine' },
        { value: 'Panama', label: 'Panama' },
        { value: 'Papouasie-Nouvelle-Guinée', label: 'Papouasie-Nouvelle-Guinée' },
        { value: 'Paraguay', label: 'Paraguay' },
        { value: 'Pays-Bas', label: 'Pays-Bas' },
        { value: 'Pérou', label: 'Pérou' },
        { value: 'Philippines', label: 'Philippines' },
        { value: 'Pologne', label: 'Pologne' },
        { value: 'Portugal', label: 'Portugal' },
        { value: 'Qatar', label: 'Qatar' },
        { value: 'Roumanie', label: 'Roumanie' },
        { value: 'Royaume-Uni', label: 'Royaume-Uni' },
        { value: 'Russie', label: 'Russie' },
        { value: 'Rwanda', label: 'Rwanda' },
        { value: 'Saint-Christophe-et-Niévès', label: 'Saint-Christophe-et-Niévès' },
        { value: 'Sainte-Lucie', label: 'Sainte-Lucie' },
        { value: 'Saint-Marin', label: 'Saint-Marin' },
        { value: 'Saint-Vincent-et-les-Grenadines', label: 'Saint-Vincent-et-les-Grenadines' },
        { value: 'Salvador', label: 'Salvador' },
        { value: 'Samoa', label: 'Samoa' },
        { value: 'Sao Tomé-et-Principe', label: 'Sao Tomé-et-Principe' },
        { value: 'Sénégal', label: 'Sénégal' },
        { value: 'Serbie', label: 'Serbie' },
        { value: 'Seychelles', label: 'Seychelles' },
        { value: 'Sierra Leone', label: 'Sierra Leone' },
        { value: 'Singapour', label: 'Singapour' },
        { value: 'Slovaquie', label: 'Slovaquie' },
        { value: 'Slovénie', label: 'Slovénie' },
        { value: 'Somalie', label: 'Somalie' },
        { value: 'Soudan', label: 'Soudan' },
        { value: 'Soudan du Sud', label: 'Soudan du Sud' },
        { value: 'Sri Lanka', label: 'Sri Lanka' },
        { value: 'Suède', label: 'Suède' },
        { value: 'Suisse', label: 'Suisse' },
        { value: 'Suriname', label: 'Suriname' },
        { value: 'Syrie', label: 'Syrie' },
        { value: 'Tadjikistan', label: 'Tadjikistan' },
        { value: 'Tanzanie', label: 'Tanzanie' },
        { value: 'Tchad', label: 'Tchad' },
        { value: 'République tchèque', label: 'République tchèque' },
        { value: 'Thaïlande', label: 'Thaïlande' },
        { value: 'Timor oriental', label: 'Timor oriental' },
        { value: 'Togo', label: 'Togo' },
        { value: 'Tonga', label: 'Tonga' },
        { value: 'Trinité-et-Tobago', label: 'Trinité-et-Tobago' },
        { value: 'Tunisie', label: 'Tunisie' },
        { value: 'Turkménistan', label: 'Turkménistan' },
        { value: 'Turquie', label: 'Turquie' },
        { value: 'Tuvalu', label: 'Tuvalu' },
        { value: 'Ukraine', label: 'Ukraine' },
        { value: 'Uruguay', label: 'Uruguay' },
        { value: 'Vanuatu', label: 'Vanuatu' },
        { value: 'Vatican', label: 'Vatican' },
        { value: 'Venezuela', label: 'Venezuela' },
        { value: 'Viêt Nam', label: 'Viêt Nam' },
        { value: 'Yémen', label: 'Yémen' },
        { value: 'Zambie', label: 'Zambie' },
        { value: 'Zimbabwe', label: 'Zimbabwe' }
      ];

      // Trier les pays par ordre alphabétique
      paysList.sort((a, b) => a.label.localeCompare(b.label));

      setPays(paysList);
    } catch (error) {
      console.error("Erreur lors du chargement des pays:", error);
    }
  };

  useEffect(() => {
    fetchParcsTampon();
    fetchPays();
  }, []);

  // const fetchCamionsChargement = async (page = 1) => {
  //   try {
  //     setIsLoading(true);
  //     const response = await fetch(
  //       `${process.env.REACT_APP_HOTE}/liste-chargement-internationaux/?page=${page}`
  //     );

  //     if (!response.ok) {
  //       throw new Error("Erreur lors de la récupération des camions en chargement");
  //     }

  //     const data = await response.json();
  //     setCamionsChargement(data.camions || []);
  //     setCurrentPageChargement(data.pagination?.page || 1);
  //     setTotalPagesChargement(data.pagination?.total_pages || 1);
  //     setTotalItemsChargement(data.pagination?.total_items || 0);
  //   } catch (error) {
  //     console.error("Erreur lors du fetch des camions en chargement:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  useEffect(() => {
    const fetchData = async () => {
      if (activeTab === "fifo") {
        await fetchCamions();
      } else if (activeTab === "chargement") {
        await fetchCamionsChargement();
      } else if (activeTab === "lettre_voiture") {
        await fetchCamionsLettreVoiture();
      } else if (activeTab === "parc_tampon") {
        await fetchCamionsParcTampon();
      }
      // await fetchImmatriculations();
    };
    fetchData();
  }, [activeTab]);


  // const filteredCamionsChargement = camionsChargement.filter((n) => {
  //   const searchTermLower = searchTermChargement.toLowerCase();

  //   return (
  //     // Informations véhicule
  //     (n.tete__numero_immatriculation?.toLowerCase().includes(searchTermLower)) ||
  //     (n.queue__numero_immatriculation?.toLowerCase().includes(searchTermLower)) ||
  //     (n.immatriculation?.toLowerCase().includes(searchTermLower)) ||
  //     (n.proprietaire_tete?.toLowerCase().includes(searchTermLower)) ||
  //     (n.proprietaire_queue?.toLowerCase().includes(searchTermLower)) ||
  //     (n.proprietaire_non_articule?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_proprietaire_tete?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_proprietaire_queue?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_proprietaire_non_articule?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nationalite_tete?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nationalite_queue?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nationalite_non_articule?.toLowerCase().includes(searchTermLower)) ||
  //     (n.code_nationalite_tete?.toLowerCase().includes(searchTermLower)) ||
  //     (n.code_nationalite_queue?.toLowerCase().includes(searchTermLower)) ||
  //     (n.code_nationalite_non_articule?.toLowerCase().includes(searchTermLower)) ||

  //     // Informations conducteur
  //     (n.nom_conducteur?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_permis?.toLowerCase().includes(searchTermLower)) ||
  //     (n.categorie_permis?.toLowerCase().includes(searchTermLower)) ||
  //     (n.tel_conducteur?.toLowerCase().includes(searchTermLower)) ||
  //     (n.conducteur_principal?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_permis_principal?.toLowerCase().includes(searchTermLower)) ||
  //     (n.categorie_permis_principal?.toLowerCase().includes(searchTermLower)) ||
  //     (n.tel_conducteur_principal?.toLowerCase().includes(searchTermLower)) ||
  //     (n.conducteur_assistant?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_permis_assistant?.toLowerCase().includes(searchTermLower)) ||
  //     (n.categorie_permis_assistant?.toLowerCase().includes(searchTermLower)) ||
  //     (n.tel_conducteur_assistant?.toLowerCase().includes(searchTermLower)) ||

  //     // Informations techniques - CORRECTION ICI
  //     (n.type_camion?.toLowerCase().includes(searchTermLower)) ||
  //     (n.genre?.toLowerCase().includes(searchTermLower)) ||
  //     (n.charge_utile?.toString().includes(searchTermChargement)) || // ← Changé à searchTermChargement
  //     (n.charge_utile1?.toString().includes(searchTermChargement)) || // ← Changé à searchTermChargement
  //     (n.charge_utile2?.toString().includes(searchTermChargement)) || // ← Changé à searchTermChargement
  //     (n.nombre_essieux1?.toString().includes(searchTermChargement)) || // ← Changé à searchTermChargement
  //     (n.nombre_essieux2?.toString().includes(searchTermChargement)) || // ← Changé à searchTermChargement
  //     (n.tuslock1?.toString().includes(searchTermChargement)) || // ← Changé à searchTermChargement
  //     (n.tuslock2?.toString().includes(searchTermChargement)) || // ← Changé à searchTermChargement

  //     // Fret et destination
  //     (n.fret?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nature_fret?.toLowerCase().includes(searchTermLower)) ||
  //     (n.ref_categorie?.toLowerCase().includes(searchTermLower)) ||
  //     (n.destination?.toLowerCase().includes(searchTermLower)) ||
  //     (n.pays_destination?.toLowerCase().includes(searchTermLower)) ||

  //     // Parc et statut
  //     (n.parc?.toLowerCase().includes(searchTermLower)) ||
  //     (n.type_parc?.toLowerCase().includes(searchTermLower)) ||
  //     (n.statut?.toLowerCase().includes(searchTermLower)) ||
  //     (n.droit_tour?.toLowerCase().includes(searchTermLower)) ||
  //     (n.droit_chargement?.toLowerCase().includes(searchTermLower)) ||

  //     // Dates
  //     (n.date_creation?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_modification?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_selection?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_arrivee_parc_tampon?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_sortie_parc_tampon?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_sortie_reele?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_sortie_prevuee?.toString().toLowerCase().includes(searchTermLower)) ||

  //     // Utilisateurs
  //     (n.utilisateur?.toLowerCase().includes(searchTermLower)) ||
  //     (n.utilisateur_arrivee?.toLowerCase().includes(searchTermLower)) ||
  //     (n.utilisateur_sortie?.toLowerCase().includes(searchTermLower)) ||

  //     // Autres
  //     (n.nom_parc_tampon?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nom_bailleur?.toLowerCase().includes(searchTermLower)) ||
  //     (n.reference_carte_transport_1?.toLowerCase().includes(searchTermLower)) ||
  //     (n.reference_carte_transport_2?.toLowerCase().includes(searchTermLower)) ||

  //     // Recherche combinée pour le camion complet
  //     (`${n.tete || ''} ${n.queue || ''}`.toLowerCase().includes(searchTermLower)) ||
  //     (`${n.tete__numero_immatriculation || ''} ${n.queue__numero_immatriculation || ''}`.toLowerCase().includes(searchTermLower))
  //   );
  // });

  const filteredCamionsChargement = filterCamions(
    camionsChargement,
    searchTermChargement,
    visibleChargementColumns
  );


  // const filteredCamionsLettreVoiture = camionsLettreVoiture.filter((n) => {
  //   const searchTermLower = searchTermLettreVoiture.toLowerCase();

  //   return (
  //     // Informations véhicule
  //     (n.tete__numero_immatriculation?.toLowerCase().includes(searchTermLower)) ||
  //     (n.queue__numero_immatriculation?.toLowerCase().includes(searchTermLower)) ||
  //     (n.immatriculation?.toLowerCase().includes(searchTermLower)) ||
  //     (n.proprietaire_tete?.toLowerCase().includes(searchTermLower)) ||
  //     (n.proprietaire_queue?.toLowerCase().includes(searchTermLower)) ||
  //     (n.proprietaire_non_articule?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_proprietaire_tete?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_proprietaire_queue?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_proprietaire_non_articule?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nationalite_tete?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nationalite_queue?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nationalite_non_articule?.toLowerCase().includes(searchTermLower)) ||
  //     (n.code_nationalite_tete?.toLowerCase().includes(searchTermLower)) ||
  //     (n.code_nationalite_queue?.toLowerCase().includes(searchTermLower)) ||
  //     (n.code_nationalite_non_articule?.toLowerCase().includes(searchTermLower)) ||

  //     // Informations conducteur
  //     (n.nom_conducteur?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_permis?.toLowerCase().includes(searchTermLower)) ||
  //     (n.categorie_permis?.toLowerCase().includes(searchTermLower)) ||
  //     (n.tel_conducteur?.toLowerCase().includes(searchTermLower)) ||
  //     (n.conducteur_principal?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_permis_principal?.toLowerCase().includes(searchTermLower)) ||
  //     (n.categorie_permis_principal?.toLowerCase().includes(searchTermLower)) ||
  //     (n.tel_conducteur_principal?.toLowerCase().includes(searchTermLower)) ||
  //     (n.conducteur_assistant?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_permis_assistant?.toLowerCase().includes(searchTermLower)) ||
  //     (n.categorie_permis_assistant?.toLowerCase().includes(searchTermLower)) ||
  //     (n.tel_conducteur_assistant?.toLowerCase().includes(searchTermLower)) ||

  //     // Informations techniques - CORRECTION ICI
  //     (n.type_camion?.toLowerCase().includes(searchTermLower)) ||
  //     (n.genre?.toLowerCase().includes(searchTermLower)) ||
  //     (n.charge_utile?.toString().includes(searchTermLettreVoiture)) || // ← Changé à searchTermLettreVoiture
  //     (n.charge_utile1?.toString().includes(searchTermLettreVoiture)) || // ← Changé à searchTermLettreVoiture
  //     (n.charge_utile2?.toString().includes(searchTermLettreVoiture)) || // ← Changé à searchTermLettreVoiture
  //     (n.nombre_essieux1?.toString().includes(searchTermLettreVoiture)) || // ← Changé à searchTermLettreVoiture
  //     (n.nombre_essieux2?.toString().includes(searchTermLettreVoiture)) || // ← Changé à searchTermLettreVoiture
  //     (n.tuslock1?.toString().includes(searchTermLettreVoiture)) || // ← Changé à searchTermLettreVoiture
  //     (n.tuslock2?.toString().includes(searchTermLettreVoiture)) || // ← Changé à searchTermLettreVoiture

  //     // Fret et destination
  //     (n.fret?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nature_fret?.toLowerCase().includes(searchTermLower)) ||
  //     (n.ref_categorie?.toLowerCase().includes(searchTermLower)) ||
  //     (n.destination?.toLowerCase().includes(searchTermLower)) ||
  //     (n.pays_destination?.toLowerCase().includes(searchTermLower)) ||

  //     // Parc et statut
  //     (n.parc?.toLowerCase().includes(searchTermLower)) ||
  //     (n.type_parc?.toLowerCase().includes(searchTermLower)) ||
  //     (n.statut?.toLowerCase().includes(searchTermLower)) ||
  //     (n.droit_tour?.toLowerCase().includes(searchTermLower)) ||
  //     (n.droit_chargement?.toLowerCase().includes(searchTermLower)) ||

  //     // Dates
  //     (n.date_creation?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_modification?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_selection?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_arrivee_parc_tampon?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_sortie_parc_tampon?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_sortie_reele?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_sortie_prevuee?.toString().toLowerCase().includes(searchTermLower)) ||

  //     // Utilisateurs
  //     (n.utilisateur?.toLowerCase().includes(searchTermLower)) ||
  //     (n.utilisateur_arrivee?.toLowerCase().includes(searchTermLower)) ||
  //     (n.utilisateur_sortie?.toLowerCase().includes(searchTermLower)) ||

  //     // Autres
  //     (n.nom_parc_tampon?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nom_bailleur?.toLowerCase().includes(searchTermLower)) ||
  //     (n.reference_carte_transport_1?.toLowerCase().includes(searchTermLower)) ||
  //     (n.reference_carte_transport_2?.toLowerCase().includes(searchTermLower)) ||
  //     (n.lot_ref?.toLowerCase().includes(searchTermLower)) ||

  //     // Recherche combinée pour le camion complet
  //     (`${n.tete || ''} ${n.queue || ''}`.toLowerCase().includes(searchTermLower)) ||
  //     (`${n.tete__numero_immatriculation || ''} ${n.queue__numero_immatriculation || ''}`.toLowerCase().includes(searchTermLower))
  //   );
  // });

  const filteredCamionsLettreVoiture = filterCamions(
    camionsLettreVoiture,
    searchTermLettreVoiture,
    visibleLettreVoitureColumns
  );


  // const filteredCamionsAppeleCamion = camionsAppeleCamion.filter((n) => {
  //   const searchTermLower = searchTermAppeleCamion.toLowerCase();

  //   return (
  //     // Informations véhicule
  //     (n.tete__numero_immatriculation?.toLowerCase().includes(searchTermLower)) ||
  //     (n.queue__numero_immatriculation?.toLowerCase().includes(searchTermLower)) ||
  //     (n.immatriculation?.toLowerCase().includes(searchTermLower)) ||
  //     (n.proprietaire_tete?.toLowerCase().includes(searchTermLower)) ||
  //     (n.proprietaire_queue?.toLowerCase().includes(searchTermLower)) ||
  //     (n.proprietaire_non_articule?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_proprietaire_tete?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_proprietaire_queue?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_proprietaire_non_articule?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nationalite_tete?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nationalite_queue?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nationalite_non_articule?.toLowerCase().includes(searchTermLower)) ||
  //     (n.code_nationalite_tete?.toLowerCase().includes(searchTermLower)) ||
  //     (n.code_nationalite_queue?.toLowerCase().includes(searchTermLower)) ||
  //     (n.code_nationalite_non_articule?.toLowerCase().includes(searchTermLower)) ||

  //     // Informations conducteur
  //     (n.nom_conducteur?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_permis?.toLowerCase().includes(searchTermLower)) ||
  //     (n.categorie_permis?.toLowerCase().includes(searchTermLower)) ||
  //     (n.tel_conducteur?.toLowerCase().includes(searchTermLower)) ||
  //     (n.conducteur_principal?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_permis_principal?.toLowerCase().includes(searchTermLower)) ||
  //     (n.categorie_permis_principal?.toLowerCase().includes(searchTermLower)) ||
  //     (n.tel_conducteur_principal?.toLowerCase().includes(searchTermLower)) ||
  //     (n.conducteur_assistant?.toLowerCase().includes(searchTermLower)) ||
  //     (n.numero_permis_assistant?.toLowerCase().includes(searchTermLower)) ||
  //     (n.categorie_permis_assistant?.toLowerCase().includes(searchTermLower)) ||
  //     (n.tel_conducteur_assistant?.toLowerCase().includes(searchTermLower)) ||

  //     // Informations techniques - CORRECTION ICI
  //     (n.type_camion?.toLowerCase().includes(searchTermLower)) ||
  //     (n.genre?.toLowerCase().includes(searchTermLower)) ||
  //     (n.charge_utile?.toString().includes(searchTermAppeleCamion)) || // ← Changé à searchTermAppeleCamion
  //     (n.charge_utile1?.toString().includes(searchTermAppeleCamion)) || // ← Changé à searchTermAppeleCamion
  //     (n.charge_utile2?.toString().includes(searchTermAppeleCamion)) || // ← Changé à searchTermAppeleCamion
  //     (n.nombre_essieux1?.toString().includes(searchTermAppeleCamion)) || // ← Changé à searchTermAppeleCamion
  //     (n.nombre_essieux2?.toString().includes(searchTermAppeleCamion)) || // ← Changé à searchTermAppeleCamion
  //     (n.tuslock1?.toString().includes(searchTermAppeleCamion)) || // ← Changé à searchTermAppeleCamion
  //     (n.tuslock2?.toString().includes(searchTermAppeleCamion)) || // ← Changé à searchTermAppeleCamion

  //     // Fret et destination
  //     (n.fret?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nature_fret?.toLowerCase().includes(searchTermLower)) ||
  //     (n.ref_categorie?.toLowerCase().includes(searchTermLower)) ||
  //     (n.destination?.toLowerCase().includes(searchTermLower)) ||
  //     (n.pays_destination?.toLowerCase().includes(searchTermLower)) ||

  //     // Parc et statut
  //     (n.parc?.toLowerCase().includes(searchTermLower)) ||
  //     (n.type_parc?.toLowerCase().includes(searchTermLower)) ||
  //     (n.statut?.toLowerCase().includes(searchTermLower)) ||
  //     (n.droit_tour?.toLowerCase().includes(searchTermLower)) ||
  //     (n.droit_chargement?.toLowerCase().includes(searchTermLower)) ||

  //     // Dates
  //     (n.date_creation?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_modification?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_selection?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_arrivee_parc_tampon?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_sortie_parc_tampon?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_sortie_reele?.toString().toLowerCase().includes(searchTermLower)) ||
  //     (n.date_sortie_prevuee?.toString().toLowerCase().includes(searchTermLower)) ||

  //     // Utilisateurs
  //     (n.utilisateur?.toLowerCase().includes(searchTermLower)) ||
  //     (n.utilisateur_arrivee?.toLowerCase().includes(searchTermLower)) ||
  //     (n.utilisateur_sortie?.toLowerCase().includes(searchTermLower)) ||

  //     // Autres
  //     (n.nom_parc_tampon?.toLowerCase().includes(searchTermLower)) ||
  //     (n.nom_bailleur?.toLowerCase().includes(searchTermLower)) ||
  //     (n.reference_carte_transport_1?.toLowerCase().includes(searchTermLower)) ||
  //     (n.reference_carte_transport_2?.toLowerCase().includes(searchTermLower)) ||
  //     (n.lot_ref?.toLowerCase().includes(searchTermLower)) ||

  //     // Recherche combinée pour le camion complet
  //     (`${n.tete || ''} ${n.queue || ''}`.toLowerCase().includes(searchTermLower)) ||
  //     (`${n.tete__numero_immatriculation || ''} ${n.queue__numero_immatriculation || ''}`.toLowerCase().includes(searchTermLower))
  //   );
  // });

  const filteredCamionsAppeleCamion = filterCamions(
    camionsAppeleCamion,
    searchTermAppeleCamion,
    visibleAppeleCamionColumns
  );


  // Fonction pour changer de catégorie
  const handleCategoryChange = (category) => {
    setCategorie(category);

    if (allCamionsGroups && allCamionsGroups[category]) {
      setCamionsChargement(allCamionsGroups[category]);
      setCurrentPageChargement(paginationGroups[category].page);
      setTotalPagesChargement(paginationGroups[category].total_pages);
      setTotalItemsChargement(paginationGroups[category].total_items);
    }
  };


  // États à ajouter
  const [searchTermFret, setSearchTermFret] = useState("");
  const [currentPageFret, setCurrentPageFret] = useState(1);
  const [itemsPerPageFret] = useState(10);
  const [sortConfigFret, setSortConfigFret] = useState({
    key: null,
    direction: "asc",
  });

  // Fonction de tri pour les frets
  const handleSortFret = (key) => {
    let direction = "asc";
    if (sortConfigFret.key === key && sortConfigFret.direction === "asc") {
      direction = "desc";
    }
    setSortConfigFret({ key, direction });
  };


  const [selectedCamionIds, setSelectedCamionIds] = useState([]);

  const handleCheckboxChange = (id) => {
    setSelectedCamionIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const [previewFile, setPreviewFile] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const handlePrevisualisation = async (camion) => {
    if (!camion) {
      showAlert("Veuillez sélectionner un camion", "danger");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_HOTE}/previsualisation-lettre/${camion.id}/`,
        {
          method: "GET",
          headers: {
            Accept: "application/pdf, image/*", // Spécifier les types acceptés
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.error || "Erreur lors de la récupération du fichier"
        );
      }

      const contentType = response.headers.get("content-type");
      const blob = await response.blob();

      // Créer une URL pour le blob
      const fileUrl = window.URL.createObjectURL(blob);

      // Déterminer le type de fichier
      let fileType = "other";
      if (contentType.includes("pdf")) {
        fileType = "pdf";
      } else if (contentType.includes("image")) {
        fileType = "image";
      }

      setPreviewFile({
        url: fileUrl,
        type: fileType,
        name: `_lettre.${fileType === "pdf"
          ? "pdf"
          : fileType === "image"
            ? contentType.split("/")[1]
            : "file"
          }`,
      });

      setShowPreviewModal(true);
    } catch (error) {
      console.error("Erreur de prévisualisation:", error);
      showAlert(
        error.message || "Impossible de prévisualiser le fichier",
        "danger"
      );

      // Vérifier si c'est une erreur 404 (fichier non trouvé)
      if (error.message.includes("404")) {
        showAlert(
          "Aucun fichier de lettre trouvé pour cet utilisateur",
          "warning"
        );
      }
    }
  };


  const [showGlossary, setShowGlossary] = useState(false);

  const [accesGroupes, setAccesGroupes] = useState([]);
  const [groupeId, setGroupeId] = useState(null);
  const groupe = localStorage.getItem("groupe_id");

  const verifGroupe = async () => {
    const groupeStored = localStorage.getItem("groupe_id");
    const accesGroupeStored = localStorage.getItem("accesGroupe");

    if (groupeStored && accesGroupeStored) {
      setGroupeId(groupeStored);
      setAccesGroupes(JSON.parse(accesGroupeStored));
    } else {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`
        );
        if (response.status === 200) {
          const data = response.data;
          setGroupeId(data.groupe);

          let cleanedAccessArray = [];
          if (Array.isArray(data.acces)) {
            cleanedAccessArray = data.acces
              .map((item) =>
                item.acces
                  ? item.acces
                    .replace(/[\[\]']/g, "")
                    .trim()
                    .split(",")
                    .map((access) => access.trim())
                  : []
              )
              .flat();

            setAccesGroupes(cleanedAccessArray);
          }

          localStorage.setItem("groupe", data.groupe);
          localStorage.setItem(
            "accesGroupe",
            JSON.stringify(cleanedAccessArray)
          );
        }
      } catch (error) {
        // console.error('Erreur lors de la vérification du groupe', error);
      }
    }
  };

  useEffect(() => {
    if (user_id) {
      verifGroupe();
    }
  }, [user_id]);

  if (!accesGroupes.includes("Mise_en_file")) {
    return <Pas_acces />;
  }


  // Définition des onglets avec leurs droits requis
  const tabs = [
    {
      key: "fifo",
      label: "Liste FIFO",
      requiredAcces: "Liste_Fifo", // accès nécessaire
      content: <div>📋 Tableau FIFO ici</div>,
    },
    {
      key: "chargement",
      label: "Liste de sélection",
      requiredAcces: "Liste_Chargement",
      content: <div>🚛 Tableau chargement ici</div>,
    },
    {
      key: "lettre_voiture",
      label: "Lettre de voiture",
      requiredAcces: "Liste_Lettre_voiture",
      content: <div>📄 Tableau lettres de voiture ici</div>,
    },
    {
      key: "parc_tampon",
      label: "Liste sortie du parc",
      requiredAcces: "Liste_Appele_camion",
      content: <div>📄 Tableau Parc tampon ici</div>,
    },
  ];
  // Vérifie si l'utilisateur possède un accès spécifique
  const hasAccess = (code) => {
    return accesGroupes.includes(code);
  };

  // configuration pour affichage de la colonne de visibilité
  const menus = {
    fifo: {
      title: "Visibilité",
      labels: columnLabels,
      visible: visibleColumns,
      setVisible: setVisibleColumns,
    },
    chargement: {
      title: "Visibilité",
      labels: columnChargementLabels,
      visible: visibleChargementColumns,
      setVisible: setVisibleChargementColumns,
    },
    lettre_voiture: {
      title: "Visibilité",
      labels: columnLettreVoitureLabels,
      visible: visibleLettreVoitureColumns,
      setVisible: setVisibleLettreVoitureColumns,
    },
    parc_tampon: {
      title: "Visibilité",
      labels: columnAppeleCamionLabels,
      visible: visibleAppeleCamionColumns,
      setVisible: setVisibleAppeleCamionColumns,
    },
  };

  return (
    <div id="wrapper">
      <Sidebar user_id={user_id} />
      <div id="page-wrapper" className="gray-bg">
        <Navbar />
        <div>
          <div className="row wrapper border-bottom white-bg page-heading">
            <div className="col-lg-12">
              <h2 className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <FaGlobeAfrica size={25} className="mr-2" />
                  Mise en file sur {parcs.find(p => p.ref_parc === userData?.parc)?.nom_parc || parcs.find(p => p.ref_parc === parcRef)?.nom_parc || '....'}
                  <span
                    className="ml-3 toggle-icon"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowInfo(!showInfo)}
                  >
                    {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                  </span>
                </div>

                {/* Bouton d'aide complètement à droite */}
                {/* <button
                  className="btn btn-link p-0 ml-2"
                  title="Manuel d'utilisation"
                  onClick={() =>
                    navigate("/Manuel-utilisation", {
                      state: {
                        fromModule: "gestion-tours",
                        fromSection: "tour-international",
                      },
                    })
                  }
                >
                  <FaQuestionCircle size={18} />
                </button> */}
                {/* <button
                  className="btn btn-link p-0 ml-2"
                  title="Aide"
                  onClick={() => setShowGlossary(true)}
                >
                  <FaQuestionCircle size={18} />
                </button> */}
              </h2>
              <div
                className={`info-box p-0 col-lg-8 ${showInfo ? "open" : ""}`}
              >

                <small>
                  {/* <b>Légende : </b><br /> */}
                  <table className="table table-bordered ">
                    <thead>
                      <tr>
                        <th>
                          <span className="badge badge-secondary">Disponible</span>
                        </th>
                        <th>
                          <span className="badge badge-warning">En panne</span>
                        </th>
                        <th>
                          <span className="badge badge-warning">Chauffeur indisponible</span>
                        </th>
                        <th>
                          <span className="badge bg-success">Chargement de marchandises</span>
                        </th>
                        <th>
                          <span className="badge bg-info">Lettre de voiture</span>
                        </th>
                        <th>
                          <span className="badge bg-primary">Transport de marchandises</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          Le camion est enregistré dans le système  selon l'ordre d'arrivée et prêt pour sélection.
                        </td>
                        <td>
                          Le camion, auparavant disponible, est temporairement indisponible ou hors service.
                        </td>
                        <td>
                          Le chauffeur du camion est momentanément indisponible.
                        </td>
                        <td>
                          Le camion a été sélectionné et s'apprête pour sortir du parc de regroupement.
                        </td>
                        <td>
                          Le camion a reçu sa lettre de voiture et son contrat de transport et est autorisé à sorti du parc .
                        </td>
                        <td>
                          Le camion est en route vers le parc tampon .
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </small>
              </div>
              {/* <small>Liste des camions internationaux.</small><br /> */}

              <small id="hbreadcrumb" className="d-flex justify-content-end">
                <ol className="breadcrumb custom-breadcrumb">
                  <li className="breadcrumb-item custom-breadcrumb-item">
                    <Link to={`/Menu`}> Accueil</Link>
                  </li>

                  {parcRef && (
                    <li className="breadcrumb-item custom-breadcrumb-item active">
                      <Link to={`/Parcs`}>Mise en file</Link>
                    </li>
                  )}

                  <li className="breadcrumb-item custom-breadcrumb-item">
                    {parcs.find(p => p.ref_parc === userData?.parc)?.nom_parc || parcs.find(p => p.ref_parc === parcRef)?.nom_parc || '....'}
                  </li>
                </ol>
              </small>
            </div>
          </div>

          {alert.message && (
            <div
              className={`alert alert-${alert.type} row justify-content-between position-relative m-2`}
            >
              <div
                // Utilisation de dangerouslySetInnerHTML pour afficher le message HTML
                dangerouslySetInnerHTML={{ __html: alert.message }}
              />

              <span
                onClick={fermerNotif}
                style={{
                  position: "absolute",
                  top: "0px", // Ajustez l'espacement comme vous le souhaitez
                  right: "10px", // Ajustez l'espacement comme vous le souhaitez
                  cursor: "pointer",
                }}
              >
                <i className="fa fa-close"></i>
              </span>
            </div>
          )}

          <div className="wrapper wrapper-content animated fadeInRight mt-3">
            <div className="">
              <div className="d-flex justify-content-between align-items-center mb-3">
                {/* <h5>Liste des camions entrant nationaux </h5> */}
                <ul className="nav nav-tabs">
                  {tabs.map((tab) =>
                    accesGroupes.includes(tab.requiredAcces) ? (
                      <li className="nav-item" key={tab.key}>
                        <button
                          className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                          onClick={() => setActiveTab(tab.key)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ) : null
                  )}
                </ul>
                <div className="d-flex flex-column flex-md-row">

                  {activeTab === "fifo" && (
                    <>
                      <Button
                        variant="primary"
                        onClick={() => setShowEntrerModal(true)}
                        className="mr-2"
                      >
                        <FaPlus /> Mise en file
                      </Button>

                      <EntrerModal
                        show={showEntrerModal}
                        typeParc="international"
                        parcRef={parcRef}
                        onHide={() => setShowEntrerModal(false)}
                        onSave={handleSaveEntrerData}
                      />
                    </>
                  )}
                  {/* {activeTab === "fifo" && (
                    <Link
                      onClick={handleShowAddModal}
                      className="btn btn-success ms-0 mb-2 mb-md-0 ms-md-2 mr-2"
                      title="Enregistrer un camion"
                    >
                      <FaPlus /> Enregistrer
                    </Link>
                  )} */}


                  {/* {(userData?.parc === "Non affecté" || hasNationalAccess()) && (

                    <button
                      onClick={() => navigate("/Gestion-des-tours-national")}
                      className="btn btn-success mr-2 ms-0 mb-2 mb-md-0 ms-md-2"
                    >
                      <FaExchangeAlt className="me-1" /> Aller au fret domestique
                    </button>
                  )} */}

                  <button
                    onClick={() => {
                      if (userData?.parc && userData.parc !== "Non affecté") {
                        window.open(
                          `/ecrans/${userData.parc}/Liste-pays-destination`,
                          "_blank",
                          "noopener,noreferrer"
                        );
                      } else {
                        window.open(
                          "/Ecrans",
                          "_blank",
                          "noopener,noreferrer"
                        );
                      }
                    }}
                    className="btn btn-success mr-2 ms-0 mb-2 mb-md-0 ms-md-2"
                  >
                    <FaDesktop className="me-1" /> Ecran
                  </button>
                  {/* <button
                    onClick={() => setAfficherModalAssigner(true)}
                    className={`btn mb-2 mb-md-0 ms-0 ms-md-2 mr-2 ${selectedCamionIds.length < 1 ? 'btn-default text-dark ' : 'btn-success'}`}
                    // className="btn btn-success ms-0 mb-2 mb-md-0 ms-md-2 mr-2"
                    disabled={selectedCamionIds.length < 1}
                    title={selectedCamionIds.length < 1 ? "Sélectionnez d'abord un camion" : "Assigner ce camion à un fret"}
                  >
                    <FaBoxesPacking className="me-1" /> Assigner camion
                  </button> */}

                </div>
              </div>

              <div className="row">
                <div className="col-lg-12">
                  <div className="ibox">
                    <div className="ibox-content">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex flex-wrap align-items-center mb-2 mb-md-0 gap-md-3">
                          <div className="me-4 mb-2 mb-md-0 mr-2">
                            <select
                              value={itemsPerPage}
                              onChange={handleItemsPerPageChange}
                              className="form-select bg-default p-1"
                              style={{
                                width: "auto",
                                border: "1px black solid",
                                borderRadius: "5px",
                              }}
                            >
                              <option value={5}>5</option>
                              <option value={10}>10</option>
                              <option value={20}>20</option>
                              <option value={50}>50</option>
                            </select>
                          </div>

                          <div className="column-selector position-relative">

                            {menus[activeTab] && (
                              <MenuVisibilite
                                title={menus[activeTab].title}
                                columnLabels={menus[activeTab].labels}
                                visibleColumns={menus[activeTab].visible}
                                setVisibleColumns={menus[activeTab].setVisible}
                              />
                            )}
                          </div>
                        </div>

                        {activeTab === "fifo" && hasAccess("Liste_Fifo") ? (
                          <div className="row justify-content-center align-items-center">
                            <input
                              type="text"
                              placeholder="Rechercher..."
                              className="form-control mr-2"
                              style={{ maxWidth: "150px", width: "100%" }}
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          </div>
                        ) : activeTab === "chargement" && hasAccess("Liste_Chargement") ? (
                          <div className="row justify-content-center align-items-center mb-3">
                            <input
                              type="text"
                              placeholder="Rechercher..."
                              className="form-control"
                              style={{ maxWidth: "150px", width: "100%" }}
                              value={searchTermChargement}
                              onChange={(e) => setSearchTermChargement(e.target.value)}
                            />
                          </div>
                        ) : activeTab === "lettre_voiture" && hasAccess("Liste_Lettre_voiture") ? (
                          <div className="row justify-content-center align-items-center mb-3">
                            <input
                              type="text"
                              placeholder="Rechercher..."
                              className="form-control"
                              style={{ maxWidth: "150px", width: "100%" }}
                              value={searchTermLettreVoiture}
                              onChange={(e) => setSearchTermLettreVoiture(e.target.value)}
                            />
                          </div>
                        ) : activeTab === "parc_tampon" && hasAccess("Liste_Appele_camion") ? (
                          <div className="row justify-content-center align-items-center mb-3">
                            <input
                              type="text"
                              placeholder="Rechercher..."
                              className="form-control"
                              style={{ maxWidth: "150px", width: "100%" }}
                              value={searchTermAppeleCamion}
                              onChange={(e) => setSearchTermAppeleCamion(e.target.value)}
                            />
                          </div>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        {activeTab === "fifo" && hasAccess("Liste_Fifo") ? (
                          <div className="">
                            <table
                              className="footable table table-stripped footable-loaded tablet breakpoint"
                              data-page-size="8"
                              data-filter="#filter"
                            >
                              <thead>
                                <tr>
                                  {Object.entries(columnLabels).map(([columnKey, label]) =>
                                    visibleColumns[columnKey] && (
                                      <th
                                        key={columnKey}
                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                        onClick={() => handleSort(columnKey)}
                                      >
                                        {label}
                                        {sortConfig.key === columnKey &&
                                          (sortConfig.direction === "descending" ?
                                            <FaSortAmountUp /> : <FaSortAmountDown />)}
                                      </th>
                                    )
                                  )}

                                  {(hasAccess("Liste_Chargement") || hasAccess("Administration")) && (
                                    <th className="text-center">Actions</th>
                                  )}
                                </tr>
                              </thead>

                              <tbody>
                                {isLoading ? (
                                  <tr>
                                    <td colSpan="100%" className="text-center">
                                      <Spinner animation="border" size="sm" /> Chargement des données...
                                    </td>
                                  </tr>
                                ) : filteredCamions.length > 0 ? (
                                  filteredCamions.map((n) => (
                                    <tr key={n.id}>
                                      {visibleColumns.date_creation && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {formatDate(n.date_creation)}
                                        </td>
                                      )}

                                      {visibleColumns.ordre && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          N°{n.ordre}
                                        </td>
                                      )}

                                      {visibleColumns.atellage && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.atellage === '1' ? 'Articulé' : 'Non articulé'}
                                        </td>
                                      )}

                                      {visibleColumns.camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.atellage === '1'
                                            ? `${n.tete || ''} + ${n.queue || ''}`
                                            : n.immatriculation || ''
                                          }
                                        </td>
                                      )}

                                      {visibleColumns.reference_carte_transport_1 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.reference_carte_transport_1 || ''}
                                        </td>
                                      )}

                                      {visibleColumns.reference_carte_transport_2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.reference_carte_transport_2 || ''}
                                        </td>
                                      )}

                                      {visibleColumns.tete && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tete || ''}
                                        </td>
                                      )}

                                      {visibleColumns.queue && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.queue || ''}
                                        </td>
                                      )}

                                      {visibleColumns.immatriculation && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.immatriculation || ''}
                                        </td>
                                      )}

                                      {visibleColumns.proprietaire_tete && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.proprietaire_tete || ''}
                                        </td>
                                      )}

                                      {visibleColumns.proprietaire_queue && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.proprietaire_queue || ''}
                                        </td>
                                      )}

                                      {visibleColumns.proprietaire_non_articule && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.proprietaire_non_articule || ''}
                                        </td>
                                      )}

                                      {visibleColumns.nationalite_vehicule && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.atellage === "1"
                                            ? n.code_nationalite_tete || 'Non défini'
                                            : n.code_nationalite_non_articule || 'Non défini'
                                          }
                                        </td>
                                      )}

                                      {visibleColumns.nationalite_carte_transport_tete && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nationalite_carte_transport_tete && n.nationalite_carte_transport_tete.length > 0
                                            ? n.nationalite_carte_transport_tete.map(nat => nat.name || nat.code).join(', ')
                                            : 'Aucune'
                                          }
                                        </td>
                                      )}

                                      {visibleColumns.nationalite_carte_transport_queue && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nationalite_carte_transport_queue && n.nationalite_carte_transport_queue.length > 0
                                            ? n.nationalite_carte_transport_queue.map(nat => nat.name || nat.code).join(', ')
                                            : 'Aucune'
                                          }
                                        </td>
                                      )}

                                      {visibleColumns.nationalite_carte_transport_immatriculation && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nationalite_carte_transport_immatriculation && n.nationalite_carte_transport_immatriculation.length > 0
                                            ? n.nationalite_carte_transport_immatriculation.map(nat => nat.name || nat.code).join(', ')
                                            : 'Aucune'
                                          }
                                        </td>
                                      )}

                                      {visibleColumns.numero_proprietaire_tete && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.numero_proprietaire_tete || ''}
                                        </td>
                                      )}

                                      {visibleColumns.numero_proprietaire_queue && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.numero_proprietaire_queue || ''}
                                        </td>
                                      )}

                                      {visibleColumns.numero_proprietaire_non_articule && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.numero_proprietaire_non_articule || ''}
                                        </td>
                                      )}

                                      {visibleColumns.charge_utile && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.charge_utile || ''}
                                        </td>
                                      )}

                                      {visibleColumns.charge_utile1 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.charge_utile1 || ''}
                                        </td>
                                      )}

                                      {visibleColumns.charge_utile2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.charge_utile2 || ''}
                                        </td>
                                      )}

                                      {visibleColumns.nombre_essieux1 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nombre_essieux1 || ''}
                                        </td>
                                      )}

                                      {visibleColumns.nombre_essieux2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nombre_essieux2 || ''}
                                        </td>
                                      )}

                                      {visibleColumns.tuslock1 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tuslock1 || ''}
                                        </td>
                                      )}

                                      {visibleColumns.tuslock2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tuslock2 || ''}
                                        </td>
                                      )}

                                      {visibleColumns.conducteur_principal && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.conducteur_principal || ''}
                                        </td>
                                      )}

                                      {visibleColumns.numero_permis_principal && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.numero_permis_principal || ''}
                                        </td>
                                      )}

                                      {visibleColumns.categorie_permis_principal && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.categorie_permis_principal || ''}
                                        </td>
                                      )}

                                      {visibleColumns.tel_conducteur_principal && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tel_conducteur_principal || ''}
                                        </td>
                                      )}

                                      {visibleColumns.conducteur_assistant && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.conducteur_assistant || ''}
                                        </td>
                                      )}

                                      {visibleColumns.numero_permis_assistant && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.numero_permis_assistant || ''}
                                        </td>
                                      )}

                                      {visibleColumns.categorie_permis_assistant && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.categorie_permis_assistant || ''}
                                        </td>
                                      )}

                                      {visibleColumns.tel_conducteur_assistant && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tel_conducteur_assistant || ''}
                                        </td>
                                      )}

                                      {visibleColumns.type_camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.type_camion || ''}
                                        </td>
                                      )}

                                      {visibleColumns.genre && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.genre || ''}
                                        </td>
                                      )}

                                      {visibleColumns.statut && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.statut === "Disponible" && (
                                            <span className="badge badge-secondary text-black">Disponible</span>
                                          )}
                                          {n.statut === "Selectionne" && (
                                            <span className="badge badge-success">Chargement de marchandises</span>
                                          )}
                                          {n.statut === "Sorti" && (
                                            <span className="badge badge-primary">Transport de marchandises</span>
                                          )}
                                          {n.statut === "Quitter" && (
                                            <span className="badge badge-danger">Sorti de rang</span>
                                          )}
                                          {n.statut === "En panne" && (
                                            <span className="badge badge-warning">En panne</span>
                                          )}
                                          {n.statut === "indisponible" && (
                                            <span className="badge badge-warning">Chauffeur Indisponible</span>
                                          )}
                                        </td>
                                      )}

                                      {visibleColumns.fret && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.fret || ''}
                                        </td>
                                      )}

                                      {visibleColumns.nature_fret && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nature_fret || ''}
                                        </td>
                                      )}

                                      {visibleColumns.ref_categorie && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.ref_categorie || ''}
                                        </td>
                                      )}

                                      {visibleColumns.destination && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.destination || ''}
                                        </td>
                                      )}

                                      {visibleColumns.parc && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.parc || ''}
                                        </td>
                                      )}

                                      {visibleColumns.type_parc && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.type_parc || ''}
                                        </td>
                                      )}

                                      {visibleColumns.utilisateur && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.utilisateur ? `${n.utilisateur.nom} ${n.utilisateur.prenoms}` : ''}
                                        </td>
                                      )}

                                      {(hasAccess("Liste_Chargement") || hasAccess("Administration") || hasAccess("Liste_Fifo")) && (
                                        <td
                                          className="text-center"
                                          style={{ position: "relative" }}
                                        >
                                          <div>
                                            <button
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setOpenDropdownId(
                                                  openDropdownId === n.id
                                                    ? null
                                                    : n.id
                                                );
                                              }}
                                              style={{
                                                background: "none",
                                                border: "none",
                                                padding: "0 5px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <FaEllipsisV title="Actions" />
                                            </button>

                                            {openDropdownId === n.id && (
                                              <div
                                                style={{
                                                  position: "fixed",
                                                  zIndex: 1000,
                                                  minWidth: "60px",
                                                  right: "50px",
                                                  backgroundColor: "white",
                                                  border: "1px solid #ddd",
                                                  borderRadius: "4px",
                                                  boxShadow:
                                                    "0 2px 10px rgba(0,0,0,0.2)",
                                                  maxHeight: "150px",
                                                  overflowY: "auto",
                                                  scrollbarWidth: "thin",
                                                  scrollbarColor: "#ddd #f8f9fa",
                                                }}
                                                className="custom-scrollbar"
                                              >

                                                {(!hasAccess("Liste_Chargement") || hasAccess("Administration")) && (
                                                  <div
                                                    style={{
                                                      padding: "8px 16px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      cursor: "pointer",
                                                      ":hover": {
                                                        backgroundColor: "#f8f9fa",
                                                      },
                                                    }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleFaireSortirClick(n);
                                                      setAfficherModalSortie(true);
                                                      setOpenDropdownId(null);
                                                    }}
                                                  >
                                                    <FaSignOutAlt
                                                      className="mr-2"
                                                      style={{ color: "blue" }}
                                                      size={14}
                                                    />
                                                    <span>Sortir de rang</span>
                                                  </div>
                                                )}

                                                <div
                                                  style={{
                                                    borderTop: "1px solid #eee",
                                                  }}
                                                />

                                                {(!hasAccess("Liste_Chargement") || hasAccess("Administration")) && (
                                                  <div
                                                    style={{
                                                      padding: "8px 16px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      cursor: "pointer",
                                                      ":hover": {
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                      },
                                                    }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleShowStatutModal(n);
                                                      setOpenDropdownId(null);
                                                    }}
                                                  >
                                                    <FaExchangeAlt
                                                      className="mr-2"
                                                      style={{
                                                        color: "orange",
                                                      }}
                                                      size={14}
                                                    />
                                                    <span>Changer statut</span>
                                                  </div>
                                                )}

                                                <div
                                                  style={{
                                                    borderTop: "1px solid #eee",
                                                  }}
                                                />

                                                {(hasAccess("Liste_Chargement") || hasAccess("Administration") || !hasAccess("Liste_Fifo")) && (
                                                  <div
                                                    style={{
                                                      padding: "8px 16px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      cursor: "pointer",
                                                      ":hover": {
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                      },
                                                    }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleShowStatutConducteurModal(n);
                                                      setOpenDropdownId(null);
                                                    }}
                                                  >
                                                    <FaExchangeAlt
                                                      className="mr-2"
                                                      style={{
                                                        color: "orange",
                                                      }}
                                                      size={14}
                                                    />
                                                    <span>Conducteur indisponible</span>
                                                  </div>
                                                )}

                                                <div
                                                  style={{ borderTop: "1px solid #eee" }}
                                                />

                                                {(hasAccess("Liste_Chargement") || hasAccess("Administration") || !hasAccess("Liste_Fifo")) && (
                                                  <div
                                                    style={{
                                                      padding: "8px 16px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      cursor: "pointer",
                                                      ":hover": {
                                                        backgroundColor: "#f8f9fa",
                                                      },
                                                    }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      setSelectedCamion(n);
                                                      setShowEntrerModalConducteur(true);
                                                      setOpenDropdownId(null);
                                                    }}
                                                  >
                                                    <FaSignOutAlt
                                                      className="mr-2"
                                                      style={{ color: "green" }}
                                                      size={14}
                                                    />
                                                    <span>Remplacer chauffeur</span>
                                                  </div>
                                                )}

                                                <div
                                                  style={{
                                                    borderTop: "1px solid #eee",
                                                  }}
                                                />

                                                {(!hasAccess("Liste_Chargement") || hasAccess("Administration")) && (
                                                  <div
                                                    style={{
                                                      padding: "8px 16px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      cursor: "pointer",
                                                      ":hover": {
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                      },
                                                    }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleShowBailleursModal(n);
                                                      setOpenDropdownId(null);
                                                    }}
                                                  >
                                                    <FaExchangeAlt
                                                      className="mr-2"
                                                      style={{
                                                        color: "noir",
                                                      }}
                                                      size={14}
                                                    />
                                                    <span>Bailleurs affiliés</span>
                                                  </div>
                                                )}

                                                {(hasAccess("Liste_Chargement") || hasAccess("Administration") || hasAccess("Liste_Fifo")) && (
                                                  <div
                                                    style={{
                                                      padding: "8px 16px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      cursor: "pointer",
                                                      ":hover": {
                                                        backgroundColor: "#f8f9fa",
                                                      },
                                                    }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      setSelectedCamion(n);
                                                      setShowModalHistorique(true);
                                                      setOpenDropdownId(null);
                                                    }}
                                                  >
                                                    <FaHistory
                                                      className="mr-2"
                                                      style={{ color: "green" }}
                                                      size={14}
                                                    />
                                                    <span>Historique</span>
                                                  </div>
                                                )}

                                              </div>
                                            )}
                                          </div>
                                        </td>
                                      )}
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="100%" className="text-center text-muted">
                                      Aucun camion à afficher
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        ) : activeTab === "chargement" && hasAccess("Liste_Chargement") ? (
                          <div className="table-responsive">
                            <table className="footable table table-stripped footable-loaded tablet breakpoint">
                              <thead>
                                <tr>
                                  {Object.entries(columnChargementLabels).map(([columnKey, label]) =>
                                    visibleChargementColumns[columnKey] && (
                                      <th
                                        key={columnKey}
                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                        onClick={() => handleSort(columnKey)}
                                      >
                                        {label}
                                        {sortConfig.key === columnKey &&
                                          (sortConfig.direction === "descending" ?
                                            <FaSortAmountUp /> : <FaSortAmountDown />)}
                                      </th>
                                    )
                                  )}
                                  <th className="text-center">Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {isLoading ? (
                                  <tr>
                                    <td colSpan={Object.keys(visibleChargementColumns).filter(k => visibleChargementColumns[k]).length + 1} className="text-center">
                                      <Spinner animation="border" size="sm" /> Chargement des données...
                                    </td>
                                  </tr>
                                ) : filteredCamionsChargement.length > 0 ? (
                                  filteredCamionsChargement.map((n) => (
                                    <tr key={n.id}>
                                      {visibleChargementColumns.date_creation && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {formatDate(n.date_creation)}
                                        </td>
                                      )}

                                      {visibleChargementColumns.date_selection && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {formatDate(n.date_selection)}
                                        </td>
                                      )}

                                      {visibleChargementColumns.ordre && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          N°{n.ordre}
                                        </td>
                                      )}

                                      {visibleChargementColumns.atellage && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.atellage === '1' ? 'Articulé' : 'Non articulé'}
                                        </td>
                                      )}

                                      {visibleChargementColumns.camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.atellage === '1'
                                            ? `${n.tete || ''} + ${n.queue || ''}`
                                            : n.immatriculation || ''
                                          }
                                        </td>
                                      )}

                                      {visibleChargementColumns.reference_carte_transport_1 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.reference_carte_transport_1 || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.reference_carte_transport_2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.reference_carte_transport_2 || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.tete && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tete || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.queue && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.queue || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.immatriculation && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.immatriculation || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.proprietaire_tete && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.proprietaire_tete || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.proprietaire_queue && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.proprietaire_queue || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.proprietaire_non_articule && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.proprietaire_non_articule || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.nationalite_vehicule && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.atellage === "1"
                                            ? n.code_nationalite_tete || 'Non défini'
                                            : n.code_nationalite_non_articule || 'Non défini'
                                          }
                                        </td>
                                      )}

                                      {visibleChargementColumns.nationalite_carte_transport_tete && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nationalite_carte_transport_tete && n.nationalite_carte_transport_tete.length > 0
                                            ? n.nationalite_carte_transport_tete.map(nat => nat.name || nat.code).join(', ')
                                            : 'Aucune'
                                          }
                                        </td>
                                      )}

                                      {visibleChargementColumns.nationalite_carte_transport_queue && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nationalite_carte_transport_queue && n.nationalite_carte_transport_queue.length > 0
                                            ? n.nationalite_carte_transport_queue.map(nat => nat.name || nat.code).join(', ')
                                            : 'Aucune'
                                          }
                                        </td>
                                      )}

                                      {visibleChargementColumns.nationalite_carte_transport_immatriculation && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nationalite_carte_transport_immatriculation && n.nationalite_carte_transport_immatriculation.length > 0
                                            ? n.nationalite_carte_transport_immatriculation.map(nat => nat.name || nat.code).join(', ')
                                            : 'Aucune'
                                          }
                                        </td>
                                      )}

                                      {visibleChargementColumns.numero_proprietaire_tete && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.numero_proprietaire_tete || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.numero_proprietaire_queue && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.numero_proprietaire_queue || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.numero_proprietaire_non_articule && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.numero_proprietaire_non_articule || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.charge_utile && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.charge_utile || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.charge_utile1 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.charge_utile1 || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.charge_utile2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.charge_utile2 || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.nombre_essieux1 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nombre_essieux1 || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.nombre_essieux2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nombre_essieux2 || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.tuslock1 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tuslock1 || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.tuslock2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tuslock2 || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.conducteur_principal && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.conducteur_principal || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.numero_permis_principal && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.numero_permis_principal || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.categorie_permis_principal && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.categorie_permis_principal || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.tel_conducteur_principal && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tel_conducteur_principal || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.conducteur_assistant && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.conducteur_assistant || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.numero_permis_assistant && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.numero_permis_assistant || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.categorie_permis_assistant && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.categorie_permis_assistant || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.tel_conducteur_assistant && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tel_conducteur_assistant || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.type_camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.type_camion || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.statut && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {/* {n.statut === "Disponible" && (
                                                                                <span className="badge badge-secondary text-black">Disponible</span>
                                                                              )} */}
                                          {n.statut === "Selectionne" && (
                                            <span className="badge badge-success">Chargement de marchandises</span>
                                          )}
                                          {/* {n.statut === "Sorti" && (
                                            <span className="badge badge-primary">Transport de marchandises</span>
                                          )}
                                          {n.statut === "Quitter" && (
                                            <span className="badge badge-danger">Sorti de rang</span>
                                          )}
                                          {n.statut === "En panne" && (
                                            <span className="badge badge-warning">En panne</span>
                                          )} */}
                                        </td>
                                      )}

                                      {visibleChargementColumns.lot_ref && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.lot_ref || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.lot_ref2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.lot_ref2 || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.nature_fret && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nature_fret || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.ref_categorie && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.ref_categorie || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.destination && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.destination || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.parc && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.parc || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.type_parc && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.type_parc || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.utilisateur && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.utilisateur ? `${n.utilisateur.nom} ${n.utilisateur.prenoms}` : ''}
                                        </td>
                                      )}

                                      <td
                                        className="text-center"
                                        style={{ position: "relative" }}
                                      >
                                        <div>
                                          <button
                                            onClick={(e) => { e.stopPropagation(); setOpenDropdownId(openDropdownId === n.id ? null : n.id); }}
                                            style={{
                                              background: "none",
                                              border: "none",
                                              padding: "0 5px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <FaEllipsisV title="Actions" />
                                          </button>

                                          {openDropdownId === n.id && (
                                            <div
                                              style={{
                                                position: "fixed",
                                                zIndex: 1000,
                                                minWidth: "60px",
                                                right: "50px",
                                                backgroundColor: "white",
                                                border: "1px solid #ddd",
                                                borderRadius: "4px",
                                                boxShadow:
                                                  "0 2px 10px rgba(0,0,0,0.2)",
                                                maxHeight: "150px",
                                                overflowY: "auto",
                                                scrollbarWidth: "thin",
                                                scrollbarColor: "#ddd #f8f9fa",
                                              }}
                                              className="custom-scrollbar"
                                            >
                                              {/* <div
                                                style={{
                                                  padding: "8px 16px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                  ":hover": {
                                                    backgroundColor: "#f8f9fa",
                                                  },
                                                }}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleShowRemplacerModal(n);
                                                  setShowRemplacerCamionModal(true);
                                                  setOpenDropdownId(null);
                                                }}
                                              >
                                                <FaSignOutAlt
                                                  className="mr-2"
                                                  style={{ color: "blue" }}
                                                  size={14}
                                                />
                                                <span> Remplacer </span>
                                              </div> */}

                                              <div style={{ borderTop: "1px solid #eee" }} />

                                              <div
                                                style={{
                                                  padding: "8px 16px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                  ":hover": {
                                                    backgroundColor: "#f8f9fa",
                                                  },
                                                }}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setSelectedCamion(n);
                                                  setShowModalHistorique(true);
                                                  setOpenDropdownId(null);
                                                }}
                                              >
                                                <FaHistory
                                                  className="mr-2"
                                                  style={{ color: "green" }}
                                                  size={14}
                                                />
                                                <span>Historique</span>
                                              </div>


                                            </div>
                                          )}

                                        </div>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={Object.keys(visibleChargementColumns).filter(k => visibleChargementColumns[k]).length + 1} className="text-center text-muted">
                                      Aucun camion en chargement pour le moment
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        ) : activeTab === "lettre_voiture" && hasAccess("Liste_Lettre_voiture") ? (
                          <div className="table-responsive">
                            <table className="footable table table-stripped footable-loaded tablet breakpoint">
                              <thead>
                                <tr>
                                  {Object.entries(columnLettreVoitureLabels).map(([columnKey, label]) =>
                                    visibleLettreVoitureColumns[columnKey] && ( // ← Utilisez visibleLettreVoitureColumns ici
                                      <th
                                        key={columnKey}
                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                        onClick={() => handleSort(columnKey)}
                                      >
                                        {label}
                                        {sortConfig.key === columnKey &&
                                          (sortConfig.direction === "descending" ?
                                            <FaSortAmountUp /> : <FaSortAmountDown />)}
                                      </th>
                                    )
                                  )}
                                  {(!hasAccess("Liste_Chargement") || hasAccess("Administration")) && (
                                    <th className="text-center">Actions</th>
                                  )}
                                </tr>
                              </thead>
                              <tbody>
                                {isLoading ? (
                                  <tr>
                                    <td colSpan="100%" className="text-center">
                                      <Spinner animation="border" size="sm" /> Chargement des données...
                                    </td>
                                  </tr>
                                ) : filteredCamionsLettreVoiture.length > 0 ? (
                                  filteredCamionsLettreVoiture.map((n) => (
                                    <tr key={n.id}>
                                      {visibleLettreVoitureColumns.date_creation && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {formatDate(n.date_creation)}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.date_selection && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {formatDate(n.date_selection)}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.ordre && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          N°{n.ordre}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.atellage && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.atellage === '1' ? 'Articulé' : 'Non articulé'}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.atellage === '1'
                                            ? `${n.tete || ''} + ${n.queue || ''}`
                                            : n.immatriculation || ''
                                          }
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.reference_carte_transport_1 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.reference_carte_transport_1 || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.reference_carte_transport_2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.reference_carte_transport_2 || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.tete && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tete || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.queue && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.queue || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.immatriculation && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.immatriculation || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.proprietaire_tete && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.proprietaire_tete || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.proprietaire_queue && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.proprietaire_queue || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.proprietaire_non_articule && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.proprietaire_non_articule || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.nationalite_vehicule && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.nationalite_vehicule || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.nationalite_carte_transport_tete && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.nationalite_carte_transport_tete || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.nationalite_carte_transport_queue && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.nationalite_carte_transport_queue || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.nationalite_carte_transport_immatriculation && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.nationalite_carte_transport_immatriculation || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.numero_proprietaire_tete && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.numero_proprietaire_tete || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.numero_proprietaire_queue && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.numero_proprietaire_queue || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.numero_proprietaire_non_articule && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.numero_proprietaire_non_articule || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.charge_utile && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.charge_utile || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.charge_utile1 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.charge_utile1 || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.charge_utile2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.charge_utile2 || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.nombre_essieux1 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nombre_essieux1 || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.nombre_essieux2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nombre_essieux2 || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.tuslock1 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tuslock1 || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.tuslock2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tuslock2 || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.conducteur_principal && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.conducteur_principal || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.numero_permis_principal && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.numero_permis_principal || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.categorie_permis_principal && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.categorie_permis_principal || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.tel_conducteur_principal && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tel_conducteur_principal || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.conducteur_assistant && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.conducteur_assistant || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.numero_permis_assistant && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.numero_permis_assistant || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.categorie_permis_assistant && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.categorie_permis_assistant || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.tel_conducteur_assistant && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tel_conducteur_assistant || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.type_camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.type_camion || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.statut && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.statut === "lettre_dispo" && (
                                            <span className="badge badge-info">Lettre de voiture</span>
                                          )}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.lot_ref && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.lot_ref || ''}
                                        </td>
                                      )}

                                      {visibleChargementColumns.lot_ref2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.lot_ref2 || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.nature_fret && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nature_fret || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.ref_categorie && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.ref_categorie || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.destination && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.destination || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.parc && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.parc || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.type_parc && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.type_parc || ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.utilisateur && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.utilisateur ? `${n.utilisateur.nom} ${n.utilisateur.prenoms}` : ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.ref_appeler_camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.ref_appeler_camion ? `${n.ref_appeler_camion}` : ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.date_entree_appeler_camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.date_entree_appeler_camion ? `${formatDate(n.date_entree_appeler_camion)}` : ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.date_sortie_appeler_camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.date_sortie_appeler_camion ? `${formatDate(n.date_sortie_appeler_camion)}` : ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.poids_effectif_appeler_camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.poids_effectif_appeler_camion ? `${n.poids_effectif_appeler_camion}` : ''}
                                        </td>
                                      )}

                                      {visibleLettreVoitureColumns.unite_poids_appeler_camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.unite_poids_appeler_camion ? `${n.unite_poids_appeler_camion}` : ''}
                                        </td>
                                      )}

                                      {(!hasAccess("Liste_Chargement") || hasAccess("Administration")) && (
                                        <td
                                          className="text-center"
                                          style={{ position: "relative" }}
                                        >
                                          <div>
                                            <button
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setOpenDropdownId(
                                                  openDropdownId === n.id
                                                    ? null
                                                    : n.id
                                                );
                                              }}
                                              style={{
                                                background: "none",
                                                border: "none",
                                                padding: "0 5px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <FaEllipsisV title="Actions" />
                                            </button>

                                            {openDropdownId === n.id && (
                                              <div
                                                style={{
                                                  position: "fixed",
                                                  zIndex: 1000,
                                                  minWidth: "60px",
                                                  right: "50px",
                                                  backgroundColor: "white",
                                                  border: "1px solid #ddd",
                                                  borderRadius: "4px",
                                                  boxShadow:
                                                    "0 2px 10px rgba(0,0,0,0.2)",
                                                  maxHeight: "150px",
                                                  overflowY: "auto",
                                                  scrollbarWidth: "thin",
                                                  scrollbarColor: "#ddd #f8f9fa",
                                                }}
                                                className="custom-scrollbar"
                                              >
                                                {/* <div
                                                                                    style={{
                                                                                      padding: "8px 16px",
                                                                                      display: "flex",
                                                                                      alignItems: "center",
                                                                                      cursor: "pointer",
                                                                                      ":hover": {
                                                                                        backgroundColor: "#f8f9fa",
                                                                                      },
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                      e.stopPropagation();
                                                                                      handleFaireSortirClick(n);
                                                                                      setAfficherModalSortie(true);
                                                                                      setOpenDropdownId(null);
                                                                                    }}
                                                                                  >
                                                                                    <FaSignOutAlt
                                                                                      className="mr-2"
                                                                                      style={{ color: "blue" }}
                                                                                      size={14}
                                                                                    />
                                                                                    <span>Sortir de rang</span>
                                                                                  </div>
                                                                                  <div
                                                                                    style={{
                                                                                      borderTop: "1px solid #eee",
                                                                                    }}
                                                                                  /> */}

                                                {/* Dans la partie des actions pour les camions en chargement */}
                                                <div
                                                  style={{
                                                    padding: "8px 16px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    cursor: "pointer",
                                                    ":hover": {
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                    },
                                                  }}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleShowSortirModal(
                                                      n
                                                    );
                                                    setOpenDropdownId(null);
                                                  }}
                                                >
                                                  <FaOutdent
                                                    className="mr-2"
                                                    style={{
                                                      color: "blue",
                                                    }}
                                                    size={14}
                                                  />
                                                  <span>Faire sortir du parc</span>
                                                </div>

                                                <div
                                                  style={{
                                                    borderTop: "1px solid #eee",
                                                  }}
                                                />

                                                {n?.statut === "lettre_dispo" && (
                                                  <>
                                                    {/* ✅ Cas 1: sameVehicule = True → Afficher les deux lettres */}
                                                    {n?.sameVehicule === true ? (
                                                      <>
                                                        {/* Lettre 1 */}
                                                        {n?.fichier_lettre && (
                                                          <a
                                                            style={{
                                                              padding: "8px 16px",
                                                              display: "flex",
                                                              alignItems: "center",
                                                              cursor: "pointer",
                                                              ":hover": { backgroundColor: "#f8f9fa" },
                                                            }}
                                                            href={n?.fichier_lettre}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                          >
                                                            <div>
                                                              <FaEye
                                                                className="mr-2"
                                                                style={{ color: "orange" }}
                                                                size={14}
                                                              />
                                                              <span>Voir lettre 1</span>
                                                            </div>
                                                          </a>
                                                        )}

                                                        {/* Lettre 2 */}
                                                        {n?.fichier_lettre2 && (
                                                          <a
                                                            style={{
                                                              padding: "8px 16px",
                                                              display: "flex",
                                                              alignItems: "center",
                                                              cursor: "pointer",
                                                              ":hover": { backgroundColor: "#f8f9fa" },
                                                            }}
                                                            href={n?.fichier_lettre2}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                          >
                                                            <div>
                                                              <FaEye
                                                                className="mr-2"
                                                                style={{ color: "orange" }}
                                                                size={14}
                                                              />
                                                              <span>Voir lettre 2</span>
                                                            </div>
                                                          </a>
                                                        )}
                                                      </>
                                                    ) : (
                                                      /* ✅ Cas 2: sameVehicule = False → Afficher une seule lettre */
                                                      n?.fichier_lettre && (
                                                        <a
                                                          style={{
                                                            padding: "8px 16px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            cursor: "pointer",
                                                            ":hover": { backgroundColor: "#f8f9fa" },
                                                          }}
                                                          disabled={isLoadingSortiRang}
                                                          href={n?.fichier_lettre}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          {isLoadingSortiRang ? (
                                                            "Chargement..."
                                                          ) : (
                                                            <div>
                                                              <FaEye
                                                                className="mr-2"
                                                                style={{ color: "orange" }}
                                                                size={14}
                                                              />
                                                              <span>Voir lettre</span>
                                                            </div>
                                                          )}
                                                        </a>
                                                      )
                                                    )}
                                                  </>
                                                )}

                                                <div style={{ borderTop: "1px solid #eee" }} />

                                                <>
                                                  {/* ✅ Cas 1: sameVehicule = True → Afficher les deux lettres */}
                                                  {n?.sameVehicule === true ? (
                                                    <>
                                                      {/* Lettre 1 */}
                                                      {n?.contrat_lien && (
                                                        <a
                                                          style={{
                                                            padding: "8px 16px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            cursor: "pointer",
                                                            ":hover": { backgroundColor: "#f8f9fa" },
                                                          }}
                                                          href={n?.contrat_lien}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          <div>
                                                            <FaEye
                                                              className="mr-2"
                                                              style={{ color: "orange" }}
                                                              size={14}
                                                            />
                                                            <span>Voir contrat 1</span>
                                                          </div>
                                                        </a>
                                                      )}

                                                      {/* Lettre 2 */}
                                                      {n?.contrat_lien2 && (
                                                        <a
                                                          style={{
                                                            padding: "8px 16px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            cursor: "pointer",
                                                            ":hover": { backgroundColor: "#f8f9fa" },
                                                          }}
                                                          href={n?.contrat_lien2}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          <div>
                                                            <FaEye
                                                              className="mr-2"
                                                              style={{ color: "orange" }}
                                                              size={14}
                                                            />
                                                            <span>Voir contrat 2</span>
                                                          </div>
                                                        </a>
                                                      )}
                                                    </>
                                                  ) : (
                                                    /* ✅ Cas 2: sameVehicule = False → Afficher un seul contrat */
                                                    n?.contrat_lien && (
                                                      <a
                                                        style={{
                                                          padding: "8px 16px",
                                                          display: "flex",
                                                          alignItems: "center",
                                                          cursor: "pointer",
                                                          ":hover": { backgroundColor: "#f8f9fa" },
                                                        }}
                                                        disabled={isLoadingSortiRang}
                                                        href={n?.contrat_lien}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                      >
                                                        {isLoadingSortiRang ? (
                                                          "Chargement..."
                                                        ) : (
                                                          <div>
                                                            <FaEye
                                                              className="mr-2"
                                                              style={{ color: "orange" }}
                                                              size={14}
                                                            />
                                                            <span>Voir contrat</span>
                                                          </div>
                                                        )}
                                                      </a>
                                                    )
                                                  )}
                                                </>

                                                <div
                                                  style={{ borderTop: "1px solid #eee" }}
                                                />

                                                {(!hasAccess("Liste_Chargement") || hasAccess("Administration")) && (
                                                  <div
                                                    style={{
                                                      padding: "8px 16px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      cursor: "pointer",
                                                      ":hover": {
                                                        backgroundColor: "#f8f9fa",
                                                      },
                                                    }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleShowRemplacerModal(n);
                                                      setShowRemplacerCamionModal(true);
                                                      setOpenDropdownId(null);
                                                    }}
                                                  >
                                                    <FaSignOutAlt
                                                      className="mr-2"
                                                      style={{ color: "blue" }}
                                                      size={14}
                                                    />
                                                    <span>Amendement</span>
                                                  </div>
                                                )}

                                                <div
                                                  style={{ borderTop: "1px solid #eee" }}
                                                />

                                                <div
                                                  style={{
                                                    padding: "8px 16px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    cursor: "pointer",
                                                    ":hover": {
                                                      backgroundColor: "#f8f9fa",
                                                    },
                                                  }}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    setSelectedCamion(n);
                                                    setShowModalHistorique(true);
                                                    setOpenDropdownId(null);
                                                  }}
                                                >
                                                  <FaHistory
                                                    className="mr-2"
                                                    style={{ color: "green" }}
                                                    size={14}
                                                  />
                                                  <span>Historique</span>
                                                </div>

                                              </div>
                                            )}
                                          </div>
                                        </td>
                                      )}
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="100%" className="text-center text-muted">
                                      Aucun camion à afficher
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        ) : activeTab === "parc_tampon" && hasAccess("Liste_Appele_camion") ? (
                          <div className="table-responsive">
                            <table className="footable table table-stripped footable-loaded tablet breakpoint">
                              <thead>
                                <tr>
                                  {Object.entries(columnAppeleCamionLabels).map(([columnKey, label]) =>
                                    visibleAppeleCamionColumns[columnKey] && ( // ← Utilisez visibleAppeleCamionColumns ici
                                      <th
                                        key={columnKey}
                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                        onClick={() => handleSort(columnKey)}
                                      >
                                        {label}
                                        {sortConfig.key === columnKey &&
                                          (sortConfig.direction === "descending" ?
                                            <FaSortAmountUp /> : <FaSortAmountDown />)}
                                      </th>
                                    )
                                  )}
                                  {/* {(!hasAccess("Liste_Chargement") || hasAccess("Administration")) && (
                                    <th className="text-center">Actions</th>
                                  )} */}
                                </tr>
                              </thead>
                              <tbody>
                                {isLoading ? (
                                  <tr>
                                    <td colSpan="100%" className="text-center">
                                      <Spinner animation="border" size="sm" /> Chargement des données...
                                    </td>
                                  </tr>
                                ) : filteredCamionsAppeleCamion.length > 0 ? (
                                  filteredCamionsAppeleCamion.map((n) => (
                                    <tr key={n.id}>
                                      {visibleAppeleCamionColumns.date_creation && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {formatDate(n.date_creation)}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.date_selection && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {formatDate(n.date_selection)}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.ordre && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          N°{n.ordre}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.atellage && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.atellage === '1' ? 'Articulé' : 'Non articulé'}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.atellage === '1'
                                            ? `${n.tete || ''} + ${n.queue || ''}`
                                            : n.immatriculation || ''
                                          }
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.reference_carte_transport_1 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.reference_carte_transport_1 || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.reference_carte_transport_2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.reference_carte_transport_2 || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.tete && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tete || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.queue && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.queue || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.immatriculation && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.immatriculation || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.proprietaire_tete && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.proprietaire_tete || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.proprietaire_queue && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.proprietaire_queue || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.proprietaire_non_articule && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.proprietaire_non_articule || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.nationalite_vehicule && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.nationalite_vehicule || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.nationalite_carte_transport_tete && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.nationalite_carte_transport_tete || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.nationalite_carte_transport_queue && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.nationalite_carte_transport_queue || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.nationalite_carte_transport_immatriculation && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.nationalite_carte_transport_immatriculation || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.numero_proprietaire_tete && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.numero_proprietaire_tete || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.numero_proprietaire_queue && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.numero_proprietaire_queue || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.numero_proprietaire_non_articule && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.numero_proprietaire_non_articule || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.charge_utile && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.charge_utile || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.charge_utile1 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.charge_utile1 || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.charge_utile2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.charge_utile2 || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.nombre_essieux1 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nombre_essieux1 || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.nombre_essieux2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nombre_essieux2 || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.tuslock1 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tuslock1 || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.tuslock2 && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tuslock2 || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.conducteur_principal && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.conducteur_principal || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.numero_permis_principal && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.numero_permis_principal || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.categorie_permis_principal && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.categorie_permis_principal || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.tel_conducteur_principal && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tel_conducteur_principal || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.conducteur_assistant && (
                                        <td className="d-none d-md-table-cell text-justify">
                                          {n.conducteur_assistant || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.numero_permis_assistant && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.numero_permis_assistant || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.categorie_permis_assistant && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.categorie_permis_assistant || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.tel_conducteur_assistant && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.tel_conducteur_assistant || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.type_camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.type_camion || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.statut && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.statut === "Sorti" && (
                                            <span className="badge badge-primary">Transport de marchandises</span>
                                          )}
                                          {n.statut === "Quitter" && (
                                            <span className="badge badge-danger">Sorti de rang</span>
                                          )}
                                          {n.statut === "lettre_dispo" && (
                                            <span className="badge badge-info">Lettre de voiture</span>
                                          )}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.lot_ref && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.lot_ref || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.nature_fret && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.nature_fret || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.ref_categorie && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.ref_categorie || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.destination && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.destination || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.parc && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.parc || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.type_parc && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.type_parc || ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.utilisateur && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.utilisateur ? `${n.utilisateur.nom} ${n.utilisateur.prenoms}` : ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.ref_appeler_camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.ref_appeler_camion ? `${n.ref_appeler_camion}` : ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.date_entree_appeler_camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.date_entree_appeler_camion ? `${formatDate(n.date_entree_appeler_camion)}` : ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.date_sortie_appeler_camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.date_sortie_appeler_camion ? `${formatDate(n.date_sortie_appeler_camion)}` : ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.poids_effectif_appeler_camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.poids_effectif_appeler_camion ? `${n.poids_effectif_appeler_camion}` : ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.unite_poids_appeler_camion && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.unite_poids_appeler_camion ? `${n.unite_poids_appeler_camion}` : ''}
                                        </td>
                                      )}

                                      {visibleAppeleCamionColumns.date_arrivee_parc_tampon && (
                                        <td className="d-none d-md-table-cell text-center">
                                          {n.date_arrivee_parc_tampon ? `${formatDate(n.date_arrivee_parc_tampon)}` : ''}
                                        </td>
                                      )}

                                      {/* {(!hasAccess("Liste_Chargement") || hasAccess("Administration")) && (
                                        <td
                                          className="text-center"
                                          style={{ position: "relative" }}
                                        >
                                          <div>
                                            <button
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setOpenDropdownId(
                                                  openDropdownId === n.id
                                                    ? null
                                                    : n.id
                                                );
                                              }}
                                              style={{
                                                background: "none",
                                                border: "none",
                                                padding: "0 5px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <FaEllipsisV title="Actions" />
                                            </button>

                                            {openDropdownId === n.id && (
                                              <div
                                                style={{
                                                  position: "fixed",
                                                  zIndex: 1000,
                                                  minWidth: "60px",
                                                  right: "50px",
                                                  backgroundColor: "white",
                                                  border: "1px solid #ddd",
                                                  borderRadius: "4px",
                                                  boxShadow:
                                                    "0 2px 10px rgba(0,0,0,0.2)",
                                                  maxHeight: "150px",
                                                  overflowY: "auto",
                                                  scrollbarWidth: "thin",
                                                  scrollbarColor: "#ddd #f8f9fa",
                                                }}
                                                className="custom-scrollbar"
                                              >

                                                <div
                                                  style={{
                                                    padding: "8px 16px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    cursor: "pointer",
                                                    ":hover": {
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                    },
                                                  }}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleShowParcTamponModal(
                                                      n
                                                    );
                                                    setOpenDropdownId(null);
                                                  }}
                                                >
                                                  <FaOutdent
                                                    className="mr-2"
                                                    style={{
                                                      color: "blue",
                                                    }}
                                                    size={14}
                                                  />
                                                  <span>Arrivée Parc Tampon</span>
                                                </div>

                                              </div>
                                            )}
                                          </div>
                                        </td>
                                      )} */}
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="100%" className="text-center text-muted">
                                      Aucun camion à afficher
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        ) : <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "5vh", // ou 100vh si tu veux sur toute la page
                            fontSize: "20px",
                            fontWeight: "bold",
                            color: "#dc3545", // rouge style Bootstrap
                          }}
                        >
                          Vous n'avez pas accès aux listes
                        </div>}
                      </div>

                      {/* Pagination Controls */}
                      {activeTab === "fifo" && hasAccess("Liste_Fifo") ? (
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <div className="dataTables_info" role="status" aria-live="polite">
                            {totalItems === 0
                              ? "Aucun élément à afficher"
                              : `Élément ${(currentPage - 1) * itemsPerPage + 1} à ${Math.min(
                                currentPage * itemsPerPage,
                                totalItems
                              )} sur ${totalItems}`
                            }
                          </div>

                          <div>
                            <button
                              onClick={() => {
                                if (currentPage > 1) {
                                  fetchCamions(currentPage - 1);
                                }
                              }}
                              className="btn btn-light mx-1"
                              disabled={currentPage === 1}
                            >
                              <FaArrowLeft />
                            </button>

                            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                              const pageNum = i + 1;
                              return (
                                <button
                                  key={pageNum}
                                  onClick={() => fetchCamions(pageNum)}
                                  className={`btn ${currentPage === pageNum ? "btn-default" : "btn-light"} mx-1`}
                                >
                                  {pageNum}
                                </button>
                              );
                            })}

                            {totalPages > 5 && (
                              <>
                                <span className="mx-1">...</span>
                                <button
                                  onClick={() => fetchCamions(totalPages)}
                                  className="btn btn-light mx-1"
                                >
                                  {totalPages}
                                </button>
                              </>
                            )}

                            <button
                              onClick={() => {
                                if (currentPage < totalPages) {
                                  fetchCamions(currentPage + 1);
                                }
                              }}
                              className="btn btn-light mx-1"
                              disabled={currentPage === totalPages}
                            >
                              <FaArrowRight />
                            </button>
                          </div>
                        </div>
                      ) : activeTab === "chargement" && hasAccess("Liste_Chargement") ? (
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <div
                            className="dataTables_info"
                            role="status"
                            aria-live="polite"
                          >
                            {totalItemsChargement === 0
                              ? "Aucun élément à afficher"
                              : `Élément ${(currentPageChargement - 1) * itemsPerPage + 1
                              } à ${Math.min(
                                currentPageChargement * itemsPerPage,
                                totalItemsChargement
                              )} sur ${totalItemsChargement}`}
                          </div>

                          <div>
                            <button
                              onClick={() => {
                                if (currentPageChargement > 1) {
                                  fetchCamionsChargement(
                                    currentPageChargement - 1
                                  );
                                }
                              }}
                              className="btn btn-light mx-1"
                              disabled={currentPageChargement === 1}
                            >
                              <FaArrowLeft />
                            </button>

                            {Array.from(
                              { length: Math.min(5, totalPagesChargement) },
                              (_, i) => {
                                const pageNum = i + 1;
                                return (
                                  <button
                                    key={pageNum}
                                    onClick={() =>
                                      fetchCamionsChargement(pageNum)
                                    }
                                    className={`btn ${currentPageChargement === pageNum
                                      ? "btn-default"
                                      : "btn-light"
                                      } mx-1`}
                                  >
                                    {pageNum}
                                  </button>
                                );
                              }
                            )}

                            {totalPagesChargement > 5 && (
                              <>
                                <span className="mx-1">...</span>
                                <button
                                  onClick={() =>
                                    fetchCamionsChargement(totalPagesChargement)
                                  }
                                  className="btn btn-light mx-1"
                                >
                                  {totalPagesChargement}
                                </button>
                              </>
                            )}

                            <button
                              onClick={() => {
                                if (
                                  currentPageChargement < totalPagesChargement
                                ) {
                                  fetchCamionsChargement(
                                    currentPageChargement + 1
                                  );
                                }
                              }}
                              className="btn btn-light mx-1"
                              disabled={
                                currentPageChargement === totalPagesChargement
                              }
                            >
                              <FaArrowRight />
                            </button>
                          </div>
                        </div>
                      ) : activeTab === "lettre_voiture" && hasAccess("Liste_Lettre_voiture") ? (
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <div
                            className="dataTables_info"
                            role="status"
                            aria-live="polite"
                          >
                            {totalItemsLettreVoiture === 0
                              ? "Aucun élément à afficher"
                              : `Élément ${(currentPageLettreVoiture - 1) * itemsPerPage + 1
                              } à ${Math.min(
                                currentPageLettreVoiture * itemsPerPage,
                                totalItemsLettreVoiture
                              )} sur ${totalItemsLettreVoiture}`}
                          </div>

                          <div>
                            <button
                              onClick={() => {
                                if (currentPageLettreVoiture > 1) {
                                  fetchCamionsLettreVoiture(
                                    currentPageLettreVoiture - 1
                                  );
                                }
                              }}
                              className="btn btn-light mx-1"
                              disabled={currentPageLettreVoiture === 1}
                            >
                              <FaArrowLeft />
                            </button>

                            {Array.from(
                              { length: Math.min(5, totalPagesLettreVoiture) },
                              (_, i) => {
                                const pageNum = i + 1;
                                return (
                                  <button
                                    key={pageNum}
                                    onClick={() =>
                                      fetchCamionsLettreVoiture(pageNum)
                                    }
                                    className={`btn ${currentPageLettreVoiture === pageNum
                                      ? "btn-default"
                                      : "btn-light"
                                      } mx-1`}
                                  >
                                    {pageNum}
                                  </button>
                                );
                              }
                            )}

                            {totalPagesLettreVoiture > 5 && (
                              <>
                                <span className="mx-1">...</span>
                                <button
                                  onClick={() =>
                                    fetchCamionsLettreVoiture(totalPagesLettreVoiture)
                                  }
                                  className="btn btn-light mx-1"
                                >
                                  {totalPagesLettreVoiture}
                                </button>
                              </>
                            )}

                            <button
                              onClick={() => {
                                if (
                                  currentPageLettreVoiture < totalPagesLettreVoiture
                                ) {
                                  fetchCamionsLettreVoiture(
                                    currentPageLettreVoiture + 1
                                  );
                                }
                              }}
                              className="btn btn-light mx-1"
                              disabled={
                                currentPageLettreVoiture === totalPagesLettreVoiture
                              }
                            >
                              <FaArrowRight />
                            </button>
                          </div>
                        </div>
                      ) : activeTab === "parc_tampon" && hasAccess("Liste_Appele_camion") ? (
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <div
                            className="dataTables_info"
                            role="status"
                            aria-live="polite"
                          >
                            {totalItemsAppeleCamion === 0
                              ? "Aucun élément à afficher"
                              : `Élément ${(currentPageAppeleCamion - 1) * itemsPerPage + 1
                              } à ${Math.min(
                                currentPageAppeleCamion * itemsPerPage,
                                totalItemsAppeleCamion
                              )} sur ${totalItemsAppeleCamion}`}
                          </div>

                          <div>
                            <button
                              onClick={() => {
                                if (currentPageAppeleCamion > 1) {
                                  fetchCamionsParcTampon(
                                    currentPageAppeleCamion - 1
                                  );
                                }
                              }}
                              className="btn btn-light mx-1"
                              disabled={currentPageAppeleCamion === 1}
                            >
                              <FaArrowLeft />
                            </button>

                            {Array.from(
                              { length: Math.min(5, totalPagesAppeleCamion) },
                              (_, i) => {
                                const pageNum = i + 1;
                                return (
                                  <button
                                    key={pageNum}
                                    onClick={() =>
                                      fetchCamionsParcTampon(pageNum)
                                    }
                                    className={`btn ${currentPageAppeleCamion === pageNum
                                      ? "btn-default"
                                      : "btn-light"
                                      } mx-1`}
                                  >
                                    {pageNum}
                                  </button>
                                );
                              }
                            )}

                            {totalPagesAppeleCamion > 5 && (
                              <>
                                <span className="mx-1">...</span>
                                <button
                                  onClick={() =>
                                    fetchCamionsParcTampon(totalPagesAppeleCamion)
                                  }
                                  className="btn btn-light mx-1"
                                >
                                  {totalPagesAppeleCamion}
                                </button>
                              </>
                            )}

                            <button
                              onClick={() => {
                                if (
                                  currentPageAppeleCamion < totalPagesAppeleCamion
                                ) {
                                  fetchCamionsParcTampon(
                                    currentPageAppeleCamion + 1
                                  );
                                }
                              }}
                              className="btn btn-light mx-1"
                              disabled={
                                currentPageAppeleCamion === totalPagesAppeleCamion
                              }
                            >
                              <FaArrowRight />
                            </button>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer text-center">
          {/* <div className="float-right">
                        10GB of <strong>250GB</strong> Free.
                    </div> */}
          <div>
            <strong>
              <a
                href="https://www.adnservicespro.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                ADN Services
              </a>
            </strong>{" "}
            &copy; 2025. Tous droits réservés | Réalisé par{" "}
            <a
              href="https://inovact.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              INOVACT SARL
            </a>
          </div>
        </div>

        {/* Modal pour remplacer un camion après etre sélectionné  */}
        {/* <Modal show={showRemplacerCamionModal} >
          <Modal.Header>
            <Modal.Title> Remplacer un camion qui désiste au tour </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h3>Cette action permet de remplacer ce camion par un autre camion présent dans la liste fifo et ayant les mêmes critères de sélection </h3>
            Etes vous sur de vouloir continuer cette action ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseRemplacerModal}>
              Annuler
            </Button>
            <Button variant="success" onClick={handleRemplacerCamion} disabled={isLoadingRemplacer}>
              {isLoadingRemplacer ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : (
                "Confirmer"
              )}
            </Button>
          </Modal.Footer>
        </Modal> */}

        {/* Modal pour amender un camion qui n'est pas sorti du parc après émission de lettre de voiture   */}
        <Modal show={showRemplacerCamionModal} >
          <Modal.Header>
            <Modal.Title>Amendement de camion</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="alert alert-warning">
              <strong>Attention : opération sensible</strong>
            </div>

            <p>
              Cette opération permet de remplacer un camion ayant obtenu une lettre de voiture,
              mais n'ayant pas quitté le parc dans le délai réglementaire autorisé.
            </p>

            <p>
              Après confirmation, le système recherchera automatiquement un camion de
              remplacement dans la liste FIFO répondant aux mêmes critères d'éligibilité,
              afin d'assurer la continuité du processus d'attribution du fret.
            </p>

            <div className="alert alert-danger">
              <strong>Important :</strong> Cette opération est <strong>irréversible</strong>.
              <br />
              Assurez-vous que le délai réglementaire de sortie est effectivement dépassé avant de poursuivre.
            </div>

            <p className="mb-0">
              <strong>Confirmez-vous vouloir procéder à cet amendement&nbsp;?</strong>
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseRemplacerModal}>
              Annuler
            </Button>

            <Button
              variant="danger"
              onClick={handleRemplacerCamion}
              disabled={isLoading}
            >
              {isLoading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : (
                "Confirmer l'amendement"
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de confirmation pour sortir un camions du rang */}
        <Modal
          show={afficherModalSortie}
          onHide={() => setAfficherModalSortie(false)}
        >
          <Modal.Header>
            <Modal.Title>Confirmer la sortie de rang</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Êtes-vous sûr de vouloir sortir ce camion du rang ?
            <p className="mt-3">
              <strong>Note :</strong> Il perdra son rang et sera retiré de la
              file d'attente.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setAfficherModalSortie(false)}
            >
              Annuler
            </Button>
            <Button
              variant="success"
              disabled={isLoadingSortiRang}
              onClick={handleConfirmerSortieDeRang}
            >
              {isLoadingSortiRang ? "Enregistrement..." : "Confirmer"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de confirmation pour changer statut du camion si en panne ou disponible */}
        <Modal show={showStatutModal} onHide={handleCloseStatutModal}>
          <Modal.Header>
            <Modal.Title>Confirmer le changement de statut</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Êtes-vous sûr de vouloir changer le statut de ce camion ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseStatutModal}>
              Annuler
            </Button>
            <Button
              variant="success"
              onClick={handleChangerstatut}
              disabled={isLoading}
            >
              {isLoading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : (
                "Confirmer"
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de confirmation pour changer statut du camion si Conducteur indisponible ou disponible */}
        <Modal show={showStatutConducteurModal} onHide={handleCloseStatutConducteurModal}>
          <Modal.Header>
            <Modal.Title>Conducteur Disponible/Indisponible</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Marquer l'indisponibilité ou la disponibilité du conducteur
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseStatutConducteurModal}>
              Annuler
            </Button>
            <Button
              variant="success"
              onClick={handleConducteurstatut}
              disabled={isLoading}
            >
              {isLoading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : (
                "Confirmer"
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de confirmation pour sortir le camion du parc*/}
        <Modal show={showSortirModal} onHide={handleCloseSortirModal}>
          <Modal.Header>
            <Modal.Title>Confirmer la sortie</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Êtes-vous sûr de vouloir sortir ce camion ? */}
            {/* <Form.Label>Sélectionnez la lettre de voiture</Form.Label>
            <Form.Control
              type="file"
              onChange={handleFileChange}
              accept=".pdf,.jpg,.jpeg,.png"
              required
            /> */}
            Êtes-vous sûr de vouloir faire sortir ce camion ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSortirModal}>
              Annuler
            </Button>
            <Button
              variant="success"
              onClick={handleFaireSortirCamion}
              disabled={isLoadingSorti}
            >
              {isLoadingSorti ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : (
                "Confirmer"
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de prévisualisation de la lettre de voiture */}
        <Modal
          show={showPreviewModal}
          onHide={() => setShowPreviewModal(false)}
          size="lg"
          centered
        >
          <Modal.Header>
            <Modal.Title>
              Prévisualisation de la lettre de{" "}
              {selectedCamion?.tete || selectedCamion?.queue
                ? `${selectedCamion?.tete} + ${selectedCamion?.queue}`
                : selectedCamion?.immatriculation}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className="text-center"
            style={{
              minHeight: "500px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {previewFile ? (
              <>
                {previewFile.type === "pdf" ? (
                  <iframe
                    src={previewFile.url}
                    title={previewFile.name}
                    style={{ width: "100%", height: "500px", border: "none" }}
                  />
                ) : previewFile.type === "image" ? (
                  <img
                    src={previewFile.url}
                    alt={previewFile.name}
                    style={{ maxWidth: "100%", maxHeight: "500px" }}
                  />
                ) : (
                  <div>
                    <p>Type de fichier non supporté pour la prévisualisation</p>
                    <a
                      href={previewFile.url}
                      download={previewFile.name}
                      className="btn btn-primary"
                    >
                      Télécharger le fichier
                    </a>
                  </div>
                )}
              </>
            ) : (
              <div className="text-muted">Chargement...</div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowPreviewModal(false)}
            >
              Fermer
            </Button>
            {previewFile && (
              <a
                href={previewFile.url}
                download={previewFile.name}
                className="btn btn-success"
              >
                {/* <FaDownload className="mr-2" /> */}
                Télécharger
              </a>
            )}
          </Modal.Footer>
        </Modal>

        {/* Modal pour remplacer le chauffeur d'un camion */}
        <ModalConducteur
          show={showEntrerModalConducteur}
          camion={selectedCamion}
          onHide={() => {
            setShowEntrerModalConducteur(false);
            setSelectedCamion(null)
          }}
          onSave={handlerRemplacerChauffeur}
        />

        {/* Modal pour afficher l'historique du parcours d'un camion */}
        <ModalHistorique
          show={showModalHistorique}
          camion={selectedCamion}
          onHide={() => {
            setShowModalHistorique(false);
            setSelectedCamion(null)
          }}
        />

        {/* Modal pour afficher bailleurs affiliés */}
        <Modal show={showBailleursModal} onHide={handleCloseBailleursModal}>
          <Modal.Header>
            <Modal.Title>Bailleurs affiliés</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedCamion && (
              <div className="mb-3">
                <strong>Camion immatriculé :</strong>{" "}

                {selectedCamion?.atellage === "1"
                  ? `${selectedCamion?.tete || ""} + ${selectedCamion?.queue || ""}`
                  : selectedCamion?.immatriculation || ""
                }

                {" "}(
                {selectedCamion?.atellage === "1"
                  ? `${selectedCamion?.reference_carte_transport_1 || ""} / ${selectedCamion?.reference_carte_transport_2 || ""}`
                  : selectedCamion?.reference_carte_transport_1 || ""
                }
                )
              </div>
            )}

            {selectedCamion?.bailleurs_affilie_1?.length === 0 ? (
              <p className="text-muted">Aucun bailleur associé</p>
            ) : (
              <ul className="list-group">
                {selectedCamion?.bailleurs_affilie_1?.map((bailleur, index) => (
                  <li key={index} className="list-group-item">
                    <div><strong>Nom :</strong> {bailleur.name}</div>
                    <div><strong>IFU :</strong> {bailleur.ifu}</div>
                  </li>
                ))}
              </ul>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseBailleursModal}>
              Annuler
            </Button>
          </Modal.Footer>
        </Modal>

      </div>
      <GlossaireSidebar
        isOpen={showGlossary}
        onClose={() => setShowGlossary(false)}
      />
    </div>
  );
};

export default Gestion_des_tours_international;
